webpackJsonp([10],{

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(760),
  /* template */
  __webpack_require__(858),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(737), __esModule: true };

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(367);
__webpack_require__(739);
module.exports = __webpack_require__(27).Array.from;


/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(75);
var createDesc = __webpack_require__(152);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(56);
var toObject = __webpack_require__(150);
var call = __webpack_require__(371);
var isArrayIter = __webpack_require__(370);
var toLength = __webpack_require__(151);
var createProperty = __webpack_require__(738);
var getIterFn = __webpack_require__(369);

$export($export.S + $export.F * !__webpack_require__(372)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(730)(true);
// imports


// module
exports.push([module.i, "/*!\n * Viewer.js v1.13.0\n * https://fengyuanchen.github.io/viewerjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2026-09-06T10:39:42.533Z\n */.viewer-close:before,.viewer-flip-horizontal:before,.viewer-flip-vertical:before,.viewer-fullscreen-exit:before,.viewer-fullscreen:before,.viewer-next:before,.viewer-one-to-one:before,.viewer-play:before,.viewer-prev:before,.viewer-reset:before,.viewer-rotate-left:before,.viewer-rotate-right:before,.viewer-zoom-in:before,.viewer-zoom-out:before{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 560 40'%3E%3Cpath fill='%23fff' d='M49.6 17.9h20.2v3.9H49.6zm123.1 2l10.9-11 2.7 2.8-8.2 8.2 8.2 8.2-2.7 2.7-10.9-10.9zm94 0l-10.8-11-2.7 2.8 8.1 8.2-8.1 8.2 2.7 2.7 10.8-10.9zM212 9.3l20.1 10.6L212 30.5V9.3zm161.5 4.6l-7.2 6 7.2 5.9v-4h12.4v4l7.3-5.9-7.3-6v4h-12.4v-4zm40.2 12.3l5.9 7.2 5.9-7.2h-4V13.6h4l-5.9-7.3-5.9 7.3h4v12.6h-4zm35.9-16.5h6.3v2h-4.3V16h-2V9.7zm14 0h6.2V16h-2v-4.3h-4.2v-2zm6.2 14V30h-6.2v-2h4.2v-4.3h2zm-14 6.3h-6.2v-6.3h2v4.4h4.3v2zm-438 .1v-8.3H9.6v-3.9h8.2V9.7h3.9v8.2h8.1v3.9h-8.1v8.3h-3.9zM93.6 9.7h-5.8v3.9h2V30h3.8V9.7zm16.1 0h-5.8v3.9h1.9V30h3.9V9.7zm-11.9 4.1h3.9v3.9h-3.9zm0 8.2h3.9v3.9h-3.9zm244.6-11.7l7.2 5.9-7.2 6v-3.6c-5.4-.4-7.8.8-8.7 2.8-.8 1.7-1.8 4.9 2.8 8.2-6.3-2-7.5-6.9-6-11.3 1.6-4.4 8-5 11.9-4.9v-3.1zm147.2 13.4h6.3V30h-2v-4.3h-4.3v-2zm14 6.3v-6.3h6.2v2h-4.3V30h-1.9zm6.2-14h-6.2V9.7h1.9V14h4.3v2zm-13.9 0h-6.3v-2h4.3V9.7h2V16zm33.3 12.5l8.6-8.6-8.6-8.7 1.9-1.9 8.6 8.7 8.6-8.7 1.9 1.9-8.6 8.7 8.6 8.6-1.9 2-8.6-8.7-8.6 8.7-1.9-2zM297 10.3l-7.1 5.9 7.2 6v-3.6c5.3-.4 7.7.8 8.7 2.8.8 1.7 1.7 4.9-2.9 8.2 6.3-2 7.5-6.9 6-11.3-1.6-4.4-7.9-5-11.8-4.9v-3.1zm-157.3-.6c2.3 0 4.4.7 6 2l2.5-3 1.9 9.2h-9.3l2.6-3.1a6.2 6.2 0 0 0-9.9 5.1c0 3.4 2.8 6.3 6.2 6.3 2.8 0 5.1-1.9 6-4.4h4c-1 4.7-5 8.3-10 8.3a10 10 0 0 1-10-10.2 10 10 0 0 1 10-10.2z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:280px;color:transparent;display:block;font-size:0;height:20px;line-height:0;width:20px}.viewer-zoom-in:before{background-position:0 0;content:\"Zoom In\"}.viewer-zoom-out:before{background-position:-20px 0;content:\"Zoom Out\"}.viewer-one-to-one:before{background-position:-40px 0;content:\"One to One\"}.viewer-reset:before{background-position:-60px 0;content:\"Reset\"}.viewer-prev:before{background-position:-80px 0;content:\"Previous\"}.viewer-play:before{background-position:-100px 0;content:\"Play\"}.viewer-next:before{background-position:-120px 0;content:\"Next\"}.viewer-rotate-left:before{background-position:-140px 0;content:\"Rotate Left\"}.viewer-rotate-right:before{background-position:-160px 0;content:\"Rotate Right\"}.viewer-flip-horizontal:before{background-position:-180px 0;content:\"Flip Horizontal\"}.viewer-flip-vertical:before{background-position:-200px 0;content:\"Flip Vertical\"}.viewer-fullscreen:before{background-position:-220px 0;content:\"Enter Full Screen\"}.viewer-fullscreen-exit:before{background-position:-240px 0;content:\"Exit Full Screen\"}.viewer-close:before{background-position:-260px 0;content:\"Close\"}.viewer-container{bottom:0;direction:ltr;font-size:0;left:0;line-height:0;overflow:hidden;position:absolute;right:0;-webkit-tap-highlight-color:transparent;top:0;-ms-touch-action:none;touch-action:none;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.viewer-container::-moz-selection,.viewer-container ::-moz-selection{background-color:transparent}.viewer-container::selection,.viewer-container ::selection{background-color:transparent}.viewer-container:focus{outline:0}.viewer-container img{display:block;height:auto;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.viewer-canvas{bottom:0;left:0;overflow:hidden;position:absolute;right:0;top:0}.viewer-canvas>img{height:auto;margin:15px auto;max-width:90%!important;width:auto}.viewer-magnifier{background-color:#fff;background-repeat:no-repeat;border:2px solid #fff;border-radius:50%;box-shadow:0 1px 5px rgba(0,0,0,.5);box-sizing:border-box;display:none;left:16px;overflow:hidden;pointer-events:none;position:absolute;top:16px;z-index:2}.viewer-magnifier.viewer-show{display:block}.viewer-magnifier-image{left:0;max-width:none!important;position:absolute;top:0;-ms-transform-origin:center;transform-origin:center}.viewer-navigation{left:0;position:absolute;right:0;top:50%}.viewer-navigation>.viewer-next,.viewer-navigation>.viewer-prev{background-color:rgba(0,0,0,.5);border-radius:50%;cursor:pointer;height:40px;margin-top:-20px;position:absolute;width:40px}.viewer-navigation>.viewer-next:focus,.viewer-navigation>.viewer-next:hover,.viewer-navigation>.viewer-prev:focus,.viewer-navigation>.viewer-prev:hover{background-color:rgba(0,0,0,.8)}.viewer-navigation>.viewer-next:focus,.viewer-navigation>.viewer-prev:focus{box-shadow:0 0 3px #fff;outline:0}.viewer-navigation>.viewer-next:before,.viewer-navigation>.viewer-prev:before{margin:10px}.viewer-navigation>.viewer-prev{left:15px}.viewer-navigation>.viewer-next{right:15px}.viewer-navigation>.viewer-large{height:48px;margin-top:-24px;width:48px}.viewer-navigation>.viewer-large:before{margin:14px}.viewer-navigation>.viewer-small{height:32px;margin-top:-16px;width:32px}.viewer-navigation>.viewer-small:before{margin:6px}.viewer-footer{bottom:0;left:0;overflow:hidden;position:absolute;right:0;text-align:center}.viewer-navbar{background-color:rgba(0,0,0,.5);overflow:hidden}.viewer-navbar.viewer-small>.viewer-list{height:40px;>li{height:40px;width:24px}}.viewer-navbar.viewer-large>.viewer-list{height:60px;>li{height:60px;width:36px}}.viewer-list{box-sizing:content-box;height:50px;margin:0;overflow:hidden;padding:1px 0}.viewer-list>li{color:transparent;cursor:pointer;float:left;font-size:0;height:50px;line-height:0;opacity:.5;overflow:hidden;transition:opacity .15s;width:30px}.viewer-list>li:focus,.viewer-list>li:hover{opacity:.75}.viewer-list>li:focus{outline:0}.viewer-list>li+li{margin-left:1px}.viewer-list>.viewer-loading{position:relative}.viewer-list>.viewer-loading:after{border-width:2px;height:20px;margin-left:-10px;margin-top:-10px;width:20px}.viewer-list>.viewer-active,.viewer-list>.viewer-active:focus,.viewer-list>.viewer-active:hover{opacity:1}.viewer-player{background-color:#000;bottom:0;cursor:none;display:none;right:0;z-index:1}.viewer-player,.viewer-player>img{left:0;position:absolute;top:0}.viewer-toolbar>ul{display:inline-block;margin:0 auto 5px;overflow:hidden;padding:6px 3px}.viewer-toolbar>ul>li{background-color:rgba(0,0,0,.5);border-radius:50%;cursor:pointer;float:left;height:24px;overflow:hidden;transition:background-color .15s;width:24px}.viewer-toolbar>ul>li:focus,.viewer-toolbar>ul>li:hover{background-color:rgba(0,0,0,.8)}.viewer-toolbar>ul>li:focus{box-shadow:0 0 3px #fff;outline:0;position:relative;z-index:1}.viewer-toolbar>ul>li:before{margin:2px}.viewer-toolbar>ul>li+li{margin-left:1px}.viewer-toolbar>ul>.viewer-small{height:18px;margin-bottom:3px;margin-top:3px;width:18px}.viewer-toolbar>ul>.viewer-small:before{margin:-1px}.viewer-toolbar>ul>.viewer-large{height:30px;margin-bottom:-3px;margin-top:-3px;width:30px}.viewer-toolbar>ul>.viewer-large:before{margin:5px}.viewer-tooltip{background-color:rgba(0,0,0,.8);border-radius:10px;color:#fff;display:none;font-size:12px;height:20px;left:50%;line-height:20px;margin-left:-25px;margin-top:-10px;position:absolute;text-align:center;top:50%;width:50px}.viewer-title{color:#ccc;display:inline-block;font-size:12px;line-height:1.2;margin:5px 5%;max-width:90%;min-height:14px;opacity:.8;overflow:hidden;text-overflow:ellipsis;transition:opacity .15s;white-space:nowrap}.viewer-title:hover{opacity:1}.viewer-button{-webkit-app-region:no-drag;background-color:rgba(0,0,0,.5);border-radius:50%;cursor:pointer;height:80px;overflow:hidden;position:absolute;right:-40px;top:-40px;transition:background-color .15s;width:80px}.viewer-button:focus,.viewer-button:hover{background-color:rgba(0,0,0,.8)}.viewer-button:focus{box-shadow:0 0 3px #fff;outline:0}.viewer-button:before{bottom:15px;left:15px;position:absolute}.viewer-fixed{position:fixed}.viewer-open{overflow:hidden}.viewer-show{display:block}.viewer-hide{display:none}.viewer-backdrop{background-color:rgba(0,0,0,.5)}.viewer-invisible{visibility:hidden}.viewer-move{cursor:move;cursor:grab}.viewer-fade{opacity:0}.viewer-in{opacity:1}.viewer-transition{transition:all .3s}@keyframes viewer-spinner{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}.viewer-loading:after{animation:viewer-spinner 1s linear infinite;border:4px solid hsla(0,0%,100%,.1);border-left-color:hsla(0,0%,100%,.5);border-radius:50%;content:\"\";display:inline-block;height:40px;left:50%;margin-left:-20px;margin-top:-20px;position:absolute;top:50%;width:40px;z-index:1}@media (max-width:767px){.viewer-hide-xs-down{display:none}}@media (max-width:991px){.viewer-hide-sm-down{display:none}}@media (max-width:1199px){.viewer-hide-md-down{display:none}}", "", {"version":3,"sources":["C:/Users/vijay/L180/prototypes/uni-uswebapp/node_modules/viewerjs/dist/viewer.css"],"names":[],"mappings":"AAAA;;;;;;;;GAQG,AAEH,2VACI,+3CAAs5C,AACt5C,4BAA6B,AAC7B,sBAAuB,AACvB,kBAAmB,AACnB,cAAe,AACf,YAAa,AACb,YAAa,AACb,cAAe,AACf,UAAY,CACb,AAEH,uBACE,wBAAyB,AACzB,iBAAmB,CACpB,AAED,wBACE,4BAA6B,AAC7B,kBAAoB,CACrB,AAED,0BACE,4BAA6B,AAC7B,oBAAsB,CACvB,AAED,qBACE,4BAA6B,AAC7B,eAAiB,CAClB,AAED,oBACE,4BAA6B,AAC7B,kBAAoB,CACrB,AAED,oBACE,6BAA8B,AAC9B,cAAgB,CACjB,AAED,oBACE,6BAA8B,AAC9B,cAAgB,CACjB,AAED,2BACE,6BAA8B,AAC9B,qBAAuB,CACxB,AAED,4BACE,6BAA8B,AAC9B,sBAAwB,CACzB,AAED,+BACE,6BAA8B,AAC9B,yBAA2B,CAC5B,AAED,6BACE,6BAA8B,AAC9B,uBAAyB,CAC1B,AAED,0BACE,6BAA8B,AAC9B,2BAA6B,CAC9B,AAED,+BACE,6BAA8B,AAC9B,0BAA4B,CAC7B,AAED,qBACE,6BAA8B,AAC9B,eAAiB,CAClB,AAED,kBACE,SAAU,AACV,cAAe,AACf,YAAa,AACb,OAAQ,AACR,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,wCAAyC,AACzC,MAAO,AACP,sBAAuB,AACnB,kBAAmB,AACvB,2BAA4B,AAC5B,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AAED,qEACI,4BAA8B,CAC/B,AAEH,2DAEI,4BAA8B,CAC/B,AAEH,wBACI,SAAW,CACZ,AAEH,sBACI,cAAe,AACf,YAAa,AACb,0BAA4B,AAC5B,yBAA2B,AAC3B,uBAAyB,AACzB,sBAAwB,AACxB,UAAY,CACb,AAEH,eACE,SAAU,AACV,OAAQ,AACR,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,KAAO,CACR,AAED,mBACI,YAAa,AACb,iBAAkB,AAClB,wBAA0B,AAC1B,UAAY,CACb,AAEH,kBACE,sBAAuB,AACvB,4BAA6B,AAC7B,sBAAuB,AACvB,kBAAmB,AACnB,oCAAyC,AACzC,sBAAuB,AACvB,aAAc,AACd,UAAW,AACX,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,SAAU,AACV,SAAW,CACZ,AAED,8BACI,aAAe,CAChB,AAEH,wBACE,OAAQ,AACR,yBAA2B,AAC3B,kBAAmB,AACnB,MAAO,AACP,4BAA6B,AACzB,uBAAyB,CAC9B,AAED,mBACE,OAAQ,AACR,kBAAmB,AACnB,QAAS,AACT,OAAS,CACV,AAED,gEAEI,gCAAqC,AACrC,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,UAAY,CACb,AAEH,wJAIM,+BAAqC,CACtC,AAEL,4EACM,wBAAyB,AACzB,SAAW,CACZ,AAEL,8EACM,WAAa,CACd,AAEL,gCACI,SAAW,CACZ,AAEH,gCACI,UAAY,CACb,AAEH,iCACI,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AAEH,wCACM,WAAa,CACd,AAEL,iCACI,YAAa,AACb,iBAAkB,AAClB,UAAY,CACb,AAEH,wCACM,UAAY,CACb,AAEL,eACE,SAAU,AACV,OAAQ,AACR,gBAAiB,AACjB,kBAAmB,AACnB,QAAS,AACT,iBAAmB,CACpB,AAED,eACE,gCAAqC,AACrC,eAAiB,CAClB,AAED,yCACI,YAAa,AAEb,IACE,YAAa,AACb,UAAY,CACb,CACF,AAEH,yCACI,YAAa,AAEb,IACE,YAAa,AACb,UAAY,CACb,CACF,AAEH,aACE,uBAAwB,AACxB,YAAa,AACb,SAAU,AACV,gBAAiB,AACjB,aAAe,CAChB,AAED,gBACI,kBAAmB,AACnB,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,YAAa,AACb,cAAe,AACf,WAAa,AACb,gBAAiB,AACjB,wBAA0B,AAC1B,UAAY,CACb,AAEH,4CAEM,WAAc,CACf,AAEL,sBACM,SAAW,CACZ,AAEL,mBACM,eAAiB,CAClB,AAEL,6BACI,iBAAmB,CACpB,AAEH,mCACM,iBAAkB,AAClB,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,UAAY,CACb,AAEL,gGAGI,SAAW,CACZ,AAEH,eACE,sBAAuB,AACvB,SAAU,AACV,YAAa,AACb,aAAc,AAGd,QAAS,AAET,SAAW,CACZ,AAED,kCAPE,OAAQ,AACR,kBAAmB,AAEnB,KAAO,CAQN,AAEH,mBACI,qBAAsB,AACtB,kBAAmB,AACnB,gBAAiB,AACjB,eAAiB,CAClB,AAEH,sBACM,gCAAqC,AACrC,kBAAmB,AACnB,eAAgB,AAChB,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,iCAAmC,AACnC,UAAY,CACb,AAEL,wDAEQ,+BAAqC,CACtC,AAEP,4BACQ,wBAAyB,AACzB,UAAW,AACX,kBAAmB,AACnB,SAAW,CACZ,AAEP,6BACQ,UAAY,CACb,AAEP,yBACQ,eAAiB,CAClB,AAEP,iCACM,YAAa,AACb,kBAAmB,AACnB,eAAgB,AAChB,UAAY,CACb,AAEL,wCACQ,WAAa,CACd,AAEP,iCACM,YAAa,AACb,mBAAoB,AACpB,gBAAiB,AACjB,UAAY,CACb,AAEL,wCACQ,UAAY,CACb,AAEP,gBACE,gCAAqC,AACrC,mBAAoB,AACpB,WAAY,AACZ,aAAc,AACd,eAAgB,AAChB,YAAa,AACb,SAAU,AACV,iBAAkB,AAClB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,QAAS,AACT,UAAY,CACb,AAED,cACE,WAAY,AACZ,qBAAsB,AACtB,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,cAAe,AACf,gBAAiB,AACjB,WAAa,AACb,gBAAiB,AACjB,uBAAwB,AACxB,wBAA0B,AAC1B,kBAAoB,CACrB,AAED,oBACI,SAAW,CACZ,AAEH,eACE,2BAA4B,AAC5B,gCAAqC,AACrC,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,YAAa,AACb,UAAW,AACX,iCAAmC,AACnC,UAAY,CACb,AAED,0CAEI,+BAAqC,CACtC,AAEH,qBACI,wBAAyB,AACzB,SAAW,CACZ,AAEH,sBACI,YAAa,AACb,UAAW,AACX,iBAAmB,CACpB,AAEH,cACE,cAAgB,CACjB,AAED,aACE,eAAiB,CAClB,AAED,aACE,aAAe,CAChB,AAED,aACE,YAAc,CACf,AAED,iBACE,+BAAqC,CACtC,AAED,kBACE,iBAAmB,CACpB,AAED,aACE,YAAa,AACb,WAAa,CACd,AAED,aACE,SAAW,CACZ,AAED,WACE,SAAW,CACZ,AAED,mBACE,kBAAqB,CACtB,AAED,0BACE,GACE,sBAAwB,CACzB,AAED,GACE,uBAA0B,CAC3B,CACF,AAED,sBACI,4CAA6C,AAC7C,oCAA2C,AAC3C,qCAA4C,AAC5C,kBAAmB,AACnB,WAAY,AACZ,qBAAsB,AACtB,YAAa,AACb,SAAU,AACV,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,QAAS,AACT,WAAY,AACZ,SAAW,CACZ,AAEH,yBACE,qBACE,YAAc,CACf,CACF,AAED,yBACE,qBACE,YAAc,CACf,CACF,AAED,0BACE,qBACE,YAAc,CACf,CACF","file":"viewer.css","sourcesContent":["/*!\n * Viewer.js v1.13.0\n * https://fengyuanchen.github.io/viewerjs\n *\n * Copyright 2015-present Chen Fengyuan\n * Released under the MIT license\n *\n * Date: 2026-09-06T10:39:42.533Z\n */\n\n.viewer-zoom-in::before, .viewer-zoom-out::before, .viewer-one-to-one::before, .viewer-reset::before, .viewer-prev::before, .viewer-play::before, .viewer-next::before, .viewer-rotate-left::before, .viewer-rotate-right::before, .viewer-flip-horizontal::before, .viewer-flip-vertical::before, .viewer-fullscreen::before, .viewer-fullscreen-exit::before, .viewer-close::before {\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 560 40%22%3E%3Cpath fill%3D%22%23fff%22 d%3D%22M49.6 17.9h20.2v3.9H49.6zm123.1 2 10.9-11 2.7 2.8-8.2 8.2 8.2 8.2-2.7 2.7-10.9-10.9zm94 0-10.8-11-2.7 2.8 8.1 8.2-8.1 8.2 2.7 2.7 10.8-10.9zM212 9.3l20.1 10.6L212 30.5V9.3zm161.5 4.6-7.2 6 7.2 5.9v-4h12.4v4l7.3-5.9-7.3-6v4h-12.4v-4zm40.2 12.3 5.9 7.2 5.9-7.2h-4V13.6h4l-5.9-7.3-5.9 7.3h4v12.6h-4zm35.9-16.5h6.3v2h-4.3V16h-2V9.7Zm14 0h6.2V16h-2v-4.3h-4.2v-2Zm6.2 14V30h-6.2v-2h4.2v-4.3h2Zm-14 6.3h-6.2v-6.3h2v4.4h4.3v2Zm-438 .1v-8.3H9.6v-3.9h8.2V9.7h3.9v8.2h8.1v3.9h-8.1v8.3h-3.9zM93.6 9.7h-5.8v3.9h2V30h3.8V9.7zm16.1 0h-5.8v3.9h1.9V30h3.9V9.7zm-11.9 4.1h3.9v3.9h-3.9zm0 8.2h3.9v3.9h-3.9zm244.6-11.7 7.2 5.9-7.2 6v-3.6c-5.4-.4-7.8.8-8.7 2.8-.8 1.7-1.8 4.9 2.8 8.2-6.3-2-7.5-6.9-6-11.3 1.6-4.4 8-5 11.9-4.9v-3.1Zm147.2 13.4h6.3V30h-2v-4.3h-4.3v-2zm14 6.3v-6.3h6.2v2h-4.3V30h-1.9zm6.2-14h-6.2V9.7h1.9V14h4.3v2zm-13.9 0h-6.3v-2h4.3V9.7h2V16zm33.3 12.5 8.6-8.6-8.6-8.7 1.9-1.9 8.6 8.7 8.6-8.7 1.9 1.9-8.6 8.7 8.6 8.6-1.9 2-8.6-8.7-8.6 8.7-1.9-2zM297 10.3l-7.1 5.9 7.2 6v-3.6c5.3-.4 7.7.8 8.7 2.8.8 1.7 1.7 4.9-2.9 8.2 6.3-2 7.5-6.9 6-11.3-1.6-4.4-7.9-5-11.8-4.9v-3.1Zm-157.3-.6c2.3 0 4.4.7 6 2l2.5-3 1.9 9.2h-9.3l2.6-3.1a6.2 6.2 0 0 0-9.9 5.1c0 3.4 2.8 6.3 6.2 6.3 2.8 0 5.1-1.9 6-4.4h4c-1 4.7-5 8.3-10 8.3a10 10 0 0 1-10-10.2 10 10 0 0 1 10-10.2Z%22%2F%3E%3C%2Fsvg%3E\");\n    background-repeat: no-repeat;\n    background-size: 280px;\n    color: transparent;\n    display: block;\n    font-size: 0;\n    height: 20px;\n    line-height: 0;\n    width: 20px;\n  }\n\n.viewer-zoom-in::before {\n  background-position: 0 0;\n  content: 'Zoom In';\n}\n\n.viewer-zoom-out::before {\n  background-position: -20px 0;\n  content: 'Zoom Out';\n}\n\n.viewer-one-to-one::before {\n  background-position: -40px 0;\n  content: 'One to One';\n}\n\n.viewer-reset::before {\n  background-position: -60px 0;\n  content: 'Reset';\n}\n\n.viewer-prev::before {\n  background-position: -80px 0;\n  content: 'Previous';\n}\n\n.viewer-play::before {\n  background-position: -100px 0;\n  content: 'Play';\n}\n\n.viewer-next::before {\n  background-position: -120px 0;\n  content: 'Next';\n}\n\n.viewer-rotate-left::before {\n  background-position: -140px 0;\n  content: 'Rotate Left';\n}\n\n.viewer-rotate-right::before {\n  background-position: -160px 0;\n  content: 'Rotate Right';\n}\n\n.viewer-flip-horizontal::before {\n  background-position: -180px 0;\n  content: 'Flip Horizontal';\n}\n\n.viewer-flip-vertical::before {\n  background-position: -200px 0;\n  content: 'Flip Vertical';\n}\n\n.viewer-fullscreen::before {\n  background-position: -220px 0;\n  content: 'Enter Full Screen';\n}\n\n.viewer-fullscreen-exit::before {\n  background-position: -240px 0;\n  content: 'Exit Full Screen';\n}\n\n.viewer-close::before {\n  background-position: -260px 0;\n  content: 'Close';\n}\n\n.viewer-container {\n  bottom: 0;\n  direction: ltr;\n  font-size: 0;\n  left: 0;\n  line-height: 0;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  -webkit-tap-highlight-color: transparent;\n  top: 0;\n  -ms-touch-action: none;\n      touch-action: none;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n\n.viewer-container::-moz-selection, .viewer-container *::-moz-selection {\n    background-color: transparent;\n  }\n\n.viewer-container::selection,\n  .viewer-container *::selection {\n    background-color: transparent;\n  }\n\n.viewer-container:focus {\n    outline: 0;\n  }\n\n.viewer-container img {\n    display: block;\n    height: auto;\n    max-height: none !important;\n    max-width: none !important;\n    min-height: 0 !important;\n    min-width: 0 !important;\n    width: 100%;\n  }\n\n.viewer-canvas {\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.viewer-canvas > img {\n    height: auto;\n    margin: 15px auto;\n    max-width: 90% !important;\n    width: auto;\n  }\n\n.viewer-magnifier {\n  background-color: #fff;\n  background-repeat: no-repeat;\n  border: 2px solid #fff;\n  border-radius: 50%;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  box-sizing: border-box;\n  display: none;\n  left: 16px;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: 16px;\n  z-index: 2;\n}\n\n.viewer-magnifier.viewer-show {\n    display: block;\n  }\n\n.viewer-magnifier-image {\n  left: 0;\n  max-width: none !important;\n  position: absolute;\n  top: 0;\n  -ms-transform-origin: center;\n      transform-origin: center;\n}\n\n.viewer-navigation {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 50%;\n}\n\n.viewer-navigation > .viewer-prev,\n  .viewer-navigation > .viewer-next {\n    background-color: rgba(0, 0, 0, 0.5);\n    border-radius: 50%;\n    cursor: pointer;\n    height: 40px;\n    margin-top: -20px;\n    position: absolute;\n    width: 40px;\n  }\n\n.viewer-navigation > .viewer-prev:focus,\n    .viewer-navigation > .viewer-next:focus,\n    .viewer-navigation > .viewer-prev:hover,\n    .viewer-navigation > .viewer-next:hover {\n      background-color: rgba(0, 0, 0, 0.8);\n    }\n\n.viewer-navigation > .viewer-prev:focus, .viewer-navigation > .viewer-next:focus {\n      box-shadow: 0 0 3px #fff;\n      outline: 0;\n    }\n\n.viewer-navigation > .viewer-prev::before, .viewer-navigation > .viewer-next::before {\n      margin: 10px;\n    }\n\n.viewer-navigation > .viewer-prev {\n    left: 15px;\n  }\n\n.viewer-navigation > .viewer-next {\n    right: 15px;\n  }\n\n.viewer-navigation > .viewer-large {\n    height: 48px;\n    margin-top: -24px;\n    width: 48px;\n  }\n\n.viewer-navigation > .viewer-large::before {\n      margin: 14px;\n    }\n\n.viewer-navigation > .viewer-small {\n    height: 32px;\n    margin-top: -16px;\n    width: 32px;\n  }\n\n.viewer-navigation > .viewer-small::before {\n      margin: 6px;\n    }\n\n.viewer-footer {\n  bottom: 0;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  text-align: center;\n}\n\n.viewer-navbar {\n  background-color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.viewer-navbar.viewer-small > .viewer-list {\n    height: 40px;\n\n    > li {\n      height: 40px;\n      width: 24px;\n    }\n  }\n\n.viewer-navbar.viewer-large > .viewer-list {\n    height: 60px;\n\n    > li {\n      height: 60px;\n      width: 36px;\n    }\n  }\n\n.viewer-list {\n  box-sizing: content-box;\n  height: 50px;\n  margin: 0;\n  overflow: hidden;\n  padding: 1px 0;\n}\n\n.viewer-list > li {\n    color: transparent;\n    cursor: pointer;\n    float: left;\n    font-size: 0;\n    height: 50px;\n    line-height: 0;\n    opacity: 0.5;\n    overflow: hidden;\n    transition: opacity 0.15s;\n    width: 30px;\n  }\n\n.viewer-list > li:focus,\n    .viewer-list > li:hover {\n      opacity: 0.75;\n    }\n\n.viewer-list > li:focus {\n      outline: 0;\n    }\n\n.viewer-list > li + li {\n      margin-left: 1px;\n    }\n\n.viewer-list > .viewer-loading {\n    position: relative;\n  }\n\n.viewer-list > .viewer-loading::after {\n      border-width: 2px;\n      height: 20px;\n      margin-left: -10px;\n      margin-top: -10px;\n      width: 20px;\n    }\n\n.viewer-list > .viewer-active,\n  .viewer-list > .viewer-active:focus,\n  .viewer-list > .viewer-active:hover {\n    opacity: 1;\n  }\n\n.viewer-player {\n  background-color: #000;\n  bottom: 0;\n  cursor: none;\n  display: none;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.viewer-player > img {\n    left: 0;\n    position: absolute;\n    top: 0;\n  }\n\n.viewer-toolbar > ul {\n    display: inline-block;\n    margin: 0 auto 5px;\n    overflow: hidden;\n    padding: 6px 3px;\n  }\n\n.viewer-toolbar > ul > li {\n      background-color: rgba(0, 0, 0, 0.5);\n      border-radius: 50%;\n      cursor: pointer;\n      float: left;\n      height: 24px;\n      overflow: hidden;\n      transition: background-color 0.15s;\n      width: 24px;\n    }\n\n.viewer-toolbar > ul > li:focus,\n      .viewer-toolbar > ul > li:hover {\n        background-color: rgba(0, 0, 0, 0.8);\n      }\n\n.viewer-toolbar > ul > li:focus {\n        box-shadow: 0 0 3px #fff;\n        outline: 0;\n        position: relative;\n        z-index: 1;\n      }\n\n.viewer-toolbar > ul > li::before {\n        margin: 2px;\n      }\n\n.viewer-toolbar > ul > li + li {\n        margin-left: 1px;\n      }\n\n.viewer-toolbar > ul > .viewer-small {\n      height: 18px;\n      margin-bottom: 3px;\n      margin-top: 3px;\n      width: 18px;\n    }\n\n.viewer-toolbar > ul > .viewer-small::before {\n        margin: -1px;\n      }\n\n.viewer-toolbar > ul > .viewer-large {\n      height: 30px;\n      margin-bottom: -3px;\n      margin-top: -3px;\n      width: 30px;\n    }\n\n.viewer-toolbar > ul > .viewer-large::before {\n        margin: 5px;\n      }\n\n.viewer-tooltip {\n  background-color: rgba(0, 0, 0, 0.8);\n  border-radius: 10px;\n  color: #fff;\n  display: none;\n  font-size: 12px;\n  height: 20px;\n  left: 50%;\n  line-height: 20px;\n  margin-left: -25px;\n  margin-top: -10px;\n  position: absolute;\n  text-align: center;\n  top: 50%;\n  width: 50px;\n}\n\n.viewer-title {\n  color: #ccc;\n  display: inline-block;\n  font-size: 12px;\n  line-height: 1.2;\n  margin: 5px 5%;\n  max-width: 90%;\n  min-height: 14px;\n  opacity: 0.8;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: opacity 0.15s;\n  white-space: nowrap;\n}\n\n.viewer-title:hover {\n    opacity: 1;\n  }\n\n.viewer-button {\n  -webkit-app-region: no-drag;\n  background-color: rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n  cursor: pointer;\n  height: 80px;\n  overflow: hidden;\n  position: absolute;\n  right: -40px;\n  top: -40px;\n  transition: background-color 0.15s;\n  width: 80px;\n}\n\n.viewer-button:focus,\n  .viewer-button:hover {\n    background-color: rgba(0, 0, 0, 0.8);\n  }\n\n.viewer-button:focus {\n    box-shadow: 0 0 3px #fff;\n    outline: 0;\n  }\n\n.viewer-button::before {\n    bottom: 15px;\n    left: 15px;\n    position: absolute;\n  }\n\n.viewer-fixed {\n  position: fixed;\n}\n\n.viewer-open {\n  overflow: hidden;\n}\n\n.viewer-show {\n  display: block;\n}\n\n.viewer-hide {\n  display: none;\n}\n\n.viewer-backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.viewer-invisible {\n  visibility: hidden;\n}\n\n.viewer-move {\n  cursor: move;\n  cursor: grab;\n}\n\n.viewer-fade {\n  opacity: 0;\n}\n\n.viewer-in {\n  opacity: 1;\n}\n\n.viewer-transition {\n  transition: all 0.3s;\n}\n\n@keyframes viewer-spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.viewer-loading::after {\n    animation: viewer-spinner 1s linear infinite;\n    border: 4px solid rgba(255, 255, 255, 0.1);\n    border-left-color: rgba(255, 255, 255, 0.5);\n    border-radius: 50%;\n    content: '';\n    display: inline-block;\n    height: 40px;\n    left: 50%;\n    margin-left: -20px;\n    margin-top: -20px;\n    position: absolute;\n    top: 50%;\n    width: 40px;\n    z-index: 1;\n  }\n\n@media (max-width: 767px) {\n  .viewer-hide-xs-down {\n    display: none;\n  }\n}\n\n@media (max-width: 991px) {\n  .viewer-hide-sm-down {\n    display: none;\n  }\n}\n\n@media (max-width: 1199px) {\n  .viewer-hide-md-down {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(740);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(731)("d3ced628", content, true, {});

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(743));
	else if(typeof define === 'function' && define.amd)
		define(["viewerjs"], factory);
	else if(typeof exports === 'object')
		exports["VueViewer"] = factory(require("viewerjs"));
	else
		root["VueViewer"] = factory(root["Viewer"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_throttle_debounce__ = __webpack_require__(5);



var install = function install(Vue, _ref) {
  var _ref$name = _ref.name,
      name = _ref$name === undefined ? 'viewer' : _ref$name,
      _ref$debug = _ref.debug,
      debug = _ref$debug === undefined ? false : _ref$debug;

  function createViewer(el, options) {
    Vue.nextTick(function () {
      destroyViewer(el);
      el['$' + name] = new __WEBPACK_IMPORTED_MODULE_0_viewerjs___default.a(el, options);
      log('viewer created');
    });
  }

  function createObserver(el, options, debouncedCreateViewer) {
    destroyObserver(el);
    var MutationObserver = global.MutationObserver || global.WebKitMutationObserver || global.MozMutationObserver;
    if (!MutationObserver) {
      log('observer not supported');
      return;
    }
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        log('viewer mutation:' + mutation.type);
        debouncedCreateViewer(el, options);
      });
    });
    var config = { attributes: true, childList: true, characterData: true, subtree: true };
    observer.observe(el, config);
    el['$viewerMutationObserver'] = observer;
    log('observer created');
  }

  function createWatcher(el, _ref2, vnode, debouncedCreateViewer) {
    var expression = _ref2.expression;

    var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;
    if (!expression || !simplePathRE.test(expression)) {
      log('only simple dot-delimited paths can create watcher');
      return;
    }
    el['$viewerUnwatch'] = vnode.context.$watch(expression, function (newVal, oldVal) {
      log('change detected by watcher: ', expression);
      debouncedCreateViewer(el, newVal);
    }, {
      deep: true
    });
    log('watcher created, expression: ', expression);
  }

  function destroyViewer(el) {
    if (!el['$' + name]) {
      return;
    }
    el['$' + name].destroy();
    delete el['$' + name];
    log('viewer destroyed');
  }

  function destroyObserver(el) {
    if (!el['$viewerMutationObserver']) {
      return;
    }
    el['$viewerMutationObserver'].disconnect();
    delete el['$viewerMutationObserver'];
    log('observer destroyed');
  }

  function destroyWatcher(el) {
    if (!el['$viewerUnwatch']) {
      return;
    }
    el['$viewerUnwatch']();
    delete el['$viewerUnwatch'];
    log('watcher destroyed');
  }

  function log() {
    var _console;

    debug && (_console = console).log.apply(_console, arguments);
  }

  Vue.directive('viewer', {
    bind: function bind(el, binding, vnode) {
      log('viewer bind');
      var debouncedCreateViewer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_throttle_debounce__["a" /* debounce */])(50, createViewer);
      debouncedCreateViewer(el, binding.value);

      createWatcher(el, binding, vnode, debouncedCreateViewer);

      if (!binding.modifiers.static) {
        createObserver(el, binding.value, debouncedCreateViewer);
      }
    },
    unbind: function unbind(el, binding) {
      log('viewer unbind');

      destroyObserver(el);

      destroyWatcher(el);

      destroyViewer(el);
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  install: install
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;

function extend() {
  var extended = {};
  var deep = false;
  var i = 0;
  var length = arguments.length;

  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
    deep = arguments[0];
    i++;
  }

  function merge(obj) {
    for (var prop in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
          extended[prop] = extend(true, extended[prop], obj[prop]);
        } else {
          extended[prop] = obj[prop];
        }
      }
    }
  }

  for (; i < length; i++) {
    var obj = arguments[i];
    merge(obj);
  }

  return extended;
}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(9),
  /* scopeId */
  null,
  /* cssModules */
  null
)
Component.options.__file = "D:\\Workspaces\\Web\\Git\\v-viewer\\src\\component.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] component.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3091014c", Component.options)
  } else {
    hotAPI.reload("data-v-3091014c", Component.options)
  }
})()}

module.exports = Component.exports


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__component_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__component_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directive__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_viewerjs__);





/* harmony default export */ __webpack_exports__["default"] = ({
  install: function install(Vue) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$name = _ref.name,
        name = _ref$name === undefined ? 'viewer' : _ref$name,
        _ref$debug = _ref.debug,
        debug = _ref$debug === undefined ? false : _ref$debug,
        defaultOptions = _ref.defaultOptions;

    __WEBPACK_IMPORTED_MODULE_3_viewerjs___default.a.setDefaults(defaultOptions);

    Vue.component(name, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__component_vue___default.a, { name: name }));
    Vue.use(__WEBPACK_IMPORTED_MODULE_2__directive__["a" /* default */], { name: name, debug: debug });
  },
  setDefaults: function setDefaults(defaultOptions) {
    __WEBPACK_IMPORTED_MODULE_3_viewerjs___default.a.setDefaults(defaultOptions);
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debounce; });

function throttle(delay, noTrailing, callback, debounceMode) {
	var timeoutID;

	var lastExec = 0;

	if (typeof noTrailing !== 'boolean') {
		debounceMode = callback;
		callback = noTrailing;
		noTrailing = undefined;
	}

	function wrapper() {

		var self = this;
		var elapsed = Number(new Date()) - lastExec;
		var args = arguments;

		function exec() {
			lastExec = Number(new Date());
			callback.apply(self, args);
		}

		function clear() {
			timeoutID = undefined;
		}

		if (debounceMode && !timeoutID) {
			exec();
		}

		if (timeoutID) {
			clearTimeout(timeoutID);
		}

		if (debounceMode === undefined && elapsed > delay) {
			exec();
		} else if (noTrailing !== true) {
			timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
		}
	}

	return wrapper;
}

function debounce(delay, atBegin, callback) {
	return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}



/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_viewerjs__);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    images: {
      type: Array
    },
    trigger: {},
    options: {
      type: Object
    }
  },

  data: function data() {
    return {};
  },


  computed: {},

  methods: {
    createViewer: function createViewer() {
      this.$viewer && this.$viewer.destroy();
      this.$viewer = new __WEBPACK_IMPORTED_MODULE_0_viewerjs___default.a(this.$el, this.options);
      this.$emit('inited', this.$viewer);
    }
  },

  watch: {
    images: function images() {
      var _this = this;

      this.$nextTick(function () {
        _this.createViewer();
      });
    },

    trigger: {
      handler: function handler() {
        var _this2 = this;

        this.$nextTick(function () {
          _this2.createViewer();
        });
      },
      deep: true
    },
    options: {
      handler: function handler() {
        var _this3 = this;

        this.$nextTick(function () {
          _this3.createViewer();
        });
      },
      deep: true
    }
  },

  mounted: function mounted() {
    this.createViewer();
  },
  destroyed: function destroyed() {
    this.$viewer && this.$viewer.destroy();
  }
});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

g = function () {
	return this;
}();

try {
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

module.exports = g;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default", null, {
    images: _vm.images,
    options: _vm.options
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3091014c", module.exports)
  }
}

/***/ })
/******/ ]);
});

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Viewer.js v1.13.0
 * https://fengyuanchen.github.io/viewerjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2026-09-06T10:39:44.170Z
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Viewer = factory());
})(this, (function () { 'use strict';

  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }

  var DEFAULTS = {
    /**
     * Enable a modal backdrop, specify `static` for a backdrop
     * which doesn't close the modal on click.
     * @type {boolean}
     */
    backdrop: true,
    /**
     * Show the button on the top-right of the viewer.
     * @type {boolean}
     */
    button: true,
    /**
     * Show the navbar.
      * @type {boolean | number | string | Object}
     */
    navbar: true,
    /**
     * Show the navigation buttons.
      * @type {boolean | number | Object}
     */
    navigation: false,
    /**
     * Specify the visibility and the content of the title.
     * @type {boolean | number | Function | Array}
     */
    title: true,
    /**
     * Show the toolbar.
     * @type {boolean | number | Object}
     */
    toolbar: true,
    /**
     * Custom class name(s) to add to the viewer's root element.
     * @type {string}
     */
    className: '',
    /**
     * Define where to put the viewer in modal mode.
     * @type {string | Element}
     */
    container: 'body',
    /**
     * Filter the images for viewing. Return true if the image is viewable.
     * @type {Function}
     */
    filter: null,
    /**
     * Enable to request fullscreen when play.
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/FullscreenOptions}
     * @type {boolean|FullscreenOptions}
     */
    fullscreen: true,
    /**
     * Define the extra attributes to inherit from the original image.
     * @type {Array}
     */
    inheritedAttributes: ['crossOrigin', 'decoding', 'isMap', 'loading', 'referrerPolicy', 'sizes', 'srcset', 'useMap'],
    /**
     * Define the initial coverage of the viewing image.
     * @type {number}
     */
    initialCoverage: 0.9,
    /**
     * Define the initial index of the image for viewing.
     * @type {number}
     */
    initialViewIndex: 0,
    /**
     * Enable inline mode.
     * @type {boolean}
     */
    inline: false,
    /**
    * Enable to automatically play the images when playing.
    * @type {boolean}
    */
    autoplay: true,
    /**
     * The amount of time to delay between automatically cycling an image when playing.
     * @type {number}
     */
    interval: 5000,
    /**
     * Enable keyboard support.
     * @type {boolean}
     */
    keyboard: true,
    /**
     * Focus the viewer when initialized.
     * @type {boolean}
     */
    focus: true,
    /**
     * Indicate if show a loading spinner when load image or not.
     * @type {boolean}
     */
    loading: true,
    /**
     * Indicate if enable loop viewing or not.
     * @type {boolean}
     */
    loop: true,
    /**
    * Enable to preload the next or previous image before viewing it.
     * @type {boolean}
     */
    preload: true,
    /**
     * Min width of the viewer in inline mode.
     * @type {number}
     */
    minWidth: 200,
    /**
     * Min height of the viewer in inline mode.
     * @type {number}
     */
    minHeight: 100,
    /**
     * Enable to move the image.
     * @type {boolean}
     */
    movable: true,
    /**
     * Show a magnifier when hovering over the image in fullscreen mode.
     * @type {boolean | Object}
     */
    magnifier: false,
    /**
     * Enable to rotate the image.
     * @type {boolean}
     */
    rotatable: true,
    /**
    * Enable to rotate the current image by gesture.
     * @type {boolean}
     */
    rotateOnGesture: true,
    /**
     * Enable to rotate the current image by dragging on the touch screen.
     * @type {boolean}
     */
    rotateOnTouch: true,
    /**
     * Enable to scale the image.
     * @type {boolean}
     */
    scalable: true,
    /**
     * Enable to zoom the image.
     * @type {boolean}
     */
    zoomable: true,
    /**
     * Enable to zoom the current image by dragging on the touch screen.
     * @type {boolean}
     */
    zoomOnTouch: true,
    /**
     * Enable to zoom the current image by gesture.
     * @type {boolean}
     */
    zoomOnGesture: true,
    /**
     * Enable to zoom the image by wheeling mouse.
     * @type {boolean}
     */
    zoomOnWheel: true,
    /**
     * Enable to slide to the next or previous image by swiping on the touch screen.
     * @type {boolean}
     */
    slideOnTouch: true,
    /**
     * Indicate if toggle the image size between its natural size
     * and initial size when double click on the image or not.
     * @type {boolean}
     */
    toggleOnDblclick: true,
    /**
     * Show the tooltip with image ratio (percentage) when zoom in or zoom out.
     * @type {boolean}
     */
    tooltip: true,
    /**
     * Enable CSS3 Transition for some special elements.
      * @type {boolean | Object}
     */
    transition: true,
    /**
     * Define the CSS `z-index` value of viewer in modal mode.
     * @type {number}
     */
    zIndex: 2015,
    /**
     * Define the CSS `z-index` value of viewer in inline mode.
     * @type {number}
     */
    zIndexInline: 0,
    /**
     * Define the ratio when zoom the image by wheeling mouse.
     * @type {number}
     */
    zoomRatio: 0.1,
    /**
     * Define the min ratio of the image when zoom out.
      * @type {number | Function}
     */
    minZoomRatio: 0.01,
    /**
     * Define the max ratio of the image when zoom in.
      * @type {number | Function}
     */
    maxZoomRatio: 100,
    /**
     * Define where to get the original image URL for viewing.
     * @type {string | Function}
     */
    url: 'src',
    /**
     * Event shortcuts.
     * @type {Function}
     */
    ready: null,
    show: null,
    shown: null,
    hide: null,
    hidden: null,
    view: null,
    viewed: null,
    move: null,
    moved: null,
    rotate: null,
    rotated: null,
    scale: null,
    scaled: null,
    zoom: null,
    zoomed: null,
    play: null,
    stop: null
  };

  var TEMPLATE = '<div class="viewer-container" tabindex="-1" touch-action="none">' + '<div class="viewer-canvas"></div>' + '<div class="viewer-magnifier" aria-hidden="true">' + '<img class="viewer-magnifier-image" alt="">' + '</div>' + '<div class="viewer-navigation">' + '<div class="viewer-prev" data-viewer-action="prev" role="button" aria-label="Previous"></div>' + '<div class="viewer-next" data-viewer-action="next" role="button" aria-label="Next"></div>' + '</div>' + '<div class="viewer-footer">' + '<div class="viewer-title"></div>' + '<div class="viewer-toolbar"></div>' + '<div class="viewer-navbar">' + '<ul class="viewer-list" role="navigation"></ul>' + '</div>' + '</div>' + '<div class="viewer-tooltip" role="alert" aria-hidden="true"></div>' + '<div class="viewer-button" data-viewer-action="mix" role="button"></div>' + '<div class="viewer-player"></div>' + '</div>';

  var IS_BROWSER = typeof window !== 'undefined' && typeof window.document !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var HAS_POINTER_EVENT = IS_BROWSER ? 'PointerEvent' in WINDOW : false;
  var NAMESPACE = 'viewer';

  // Actions
  var ACTION_MOVE = 'move';
  var ACTION_ROTATE = 'rotate';
  var ACTION_SWITCH = 'switch';
  var ACTION_TRANSFORM = 'transform';
  var ACTION_ZOOM = 'zoom';

  // Classes
  var CLASS_ACTIVE = "".concat(NAMESPACE, "-active");
  var CLASS_CLOSE = "".concat(NAMESPACE, "-close");
  var CLASS_FADE = "".concat(NAMESPACE, "-fade");
  var CLASS_FIXED = "".concat(NAMESPACE, "-fixed");
  var CLASS_FULLSCREEN = "".concat(NAMESPACE, "-fullscreen");
  var CLASS_FULLSCREEN_EXIT = "".concat(NAMESPACE, "-fullscreen-exit");
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var CLASS_HIDE_MD_DOWN = "".concat(NAMESPACE, "-hide-md-down");
  var CLASS_HIDE_SM_DOWN = "".concat(NAMESPACE, "-hide-sm-down");
  var CLASS_HIDE_XS_DOWN = "".concat(NAMESPACE, "-hide-xs-down");
  var CLASS_IN = "".concat(NAMESPACE, "-in");
  var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
  var CLASS_LOADING = "".concat(NAMESPACE, "-loading");
  var CLASS_MOVE = "".concat(NAMESPACE, "-move");
  var CLASS_OPEN = "".concat(NAMESPACE, "-open");
  var CLASS_SHOW = "".concat(NAMESPACE, "-show");
  var CLASS_TRANSITION = "".concat(NAMESPACE, "-transition");

  // Native events
  var EVENT_CLICK = 'click';
  var EVENT_DBLCLICK = 'dblclick';
  var EVENT_DRAG_START = 'dragstart';
  var EVENT_FOCUSIN = 'focusin';
  var EVENT_KEY_DOWN = 'keydown';
  var EVENT_LOAD = 'load';
  var EVENT_ERROR = 'error';
  var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? 'touchend touchcancel' : 'mouseup';
  var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? 'touchmove' : 'mousemove';
  var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? 'touchstart' : 'mousedown';
  var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? 'pointerdown' : EVENT_TOUCH_START;
  var EVENT_POINTER_ENTER = HAS_POINTER_EVENT ? 'pointerenter' : 'mouseenter';
  var EVENT_POINTER_LEAVE = HAS_POINTER_EVENT ? 'pointerleave' : 'mouseleave';
  var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? 'pointermove' : EVENT_TOUCH_MOVE;
  var EVENT_POINTER_UP = HAS_POINTER_EVENT ? 'pointerup pointercancel' : EVENT_TOUCH_END;
  var EVENT_RESIZE = 'resize';
  var EVENT_TRANSITION_END = 'transitionend';
  var EVENT_WHEEL = 'wheel';
  var EVENT_GESTURE = 'gesturestart gesturechange gestureend';

  // Custom events
  var EVENT_READY = 'ready';
  var EVENT_SHOW = 'show';
  var EVENT_SHOWN = 'shown';
  var EVENT_HIDE = 'hide';
  var EVENT_HIDDEN = 'hidden';
  var EVENT_VIEW = 'view';
  var EVENT_VIEWED = 'viewed';
  var EVENT_MOVE = 'move';
  var EVENT_MOVED = 'moved';
  var EVENT_ROTATE = 'rotate';
  var EVENT_ROTATED = 'rotated';
  var EVENT_SCALE = 'scale';
  var EVENT_SCALED = 'scaled';
  var EVENT_ZOOM = 'zoom';
  var EVENT_ZOOMED = 'zoomed';
  var EVENT_PLAY = 'play';
  var EVENT_STOP = 'stop';

  // Data keys
  var DATA_ACTION = "".concat(NAMESPACE, "Action");

  // RegExps
  var REGEXP_SPACES = /\s+/;

  // Misc
  var BUTTONS = ['zoom-in', 'zoom-out', 'one-to-one', 'reset', 'prev', 'play', 'next', 'rotate-left', 'rotate-right', 'flip-horizontal', 'flip-vertical'];

  /**
   * Check if the given value is a string.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a string, else `false`.
   */
  function isString(value) {
    return typeof value === 'string';
  }

  /**
   * Check if the given value is not a number.
   */
  var isNaN = Number.isNaN || WINDOW.isNaN;

  /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */
  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */
  function isObject(value) {
    return _typeof(value) === 'object' && value !== null;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */
  function isPlainObject(value) {
    if (!isObject(value)) {
      return false;
    }
    try {
      var constructor = value.constructor;
      var prototype = constructor.prototype;
      return constructor && prototype && hasOwnProperty.call(prototype, 'isPrototypeOf');
    } catch (error) {
      return false;
    }
  }

  /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */
  function isFunction(value) {
    return typeof value === 'function';
  }

  /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */
  function forEach(data, callback) {
    if (data && isFunction(callback)) {
      if (Array.isArray(data) || isNumber(data.length) /* array-like */) {
        var length = data.length;
        var i;
        for (i = 0; i < length; i += 1) {
          if (callback.call(data, data[i], i, data) === false) {
            break;
          }
        }
      } else if (isObject(data)) {
        Object.keys(data).forEach(function (key) {
          callback.call(data, data[key], key, data);
        });
      }
    }
    return data;
  }

  /**
   * Inherit attributes from the original image.
   * @param {Element} image - The target image.
   * @param {Element} originalImage - The original image.
   * @param {Array} inheritedAttributes - The attributes to inherit.
   */
  function inheritAttributes(image, originalImage, inheritedAttributes) {
    forEach(inheritedAttributes, function (name) {
      var value = originalImage.getAttribute(name);
      if (value !== null) {
        image.setAttribute(name, value);
      }
    });
  }

  /**
   * Check if transition is enabled for the given action.
   * @param {Object} options - The viewer options.
   * @param {string} action - The transition action.
   * @returns {boolean} Returns `true` if transition is enabled.
   */
  function isTransitionEnabled(options, action) {
    var transition = options.transition;
    return transition && transition[action] !== false;
  }

  /**
   * Extend the given object.
   * @param {*} obj - The object to be extended.
   * @param {*} args - The rest objects which will be merged to the first object.
   * @returns {Object} The extended object.
   */
  var assign = Object.assign || function assign(obj) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (isObject(obj) && args.length > 0) {
      args.forEach(function (arg) {
        if (isObject(arg)) {
          Object.keys(arg).forEach(function (key) {
            obj[key] = arg[key];
          });
        }
      });
    }
    return obj;
  };
  var REGEXP_SUFFIX = /^(?:width|height|left|top|marginLeft|marginTop)$/;

  /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */
  function setStyle(element, styles) {
    var style = element.style;
    forEach(styles, function (value, property) {
      if (REGEXP_SUFFIX.test(property) && isNumber(value)) {
        value += 'px';
      }
      style[property] = value;
    });
  }

  /**
   * Escape a string for using in HTML.
   * @param {String} value - The string to escape.
   * @returns {String} Returns the escaped string.
   */
  function escapeHTMLEntities(value) {
    return isString(value) ? value.replace(/&(?!amp;|quot;|#39;|lt;|gt;)/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : value;
  }

  /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */
  function hasClass(element, value) {
    if (!element || !value) {
      return false;
    }
    return element.classList ? element.classList.contains(value) : element.className.split(REGEXP_SPACES).indexOf(value) > -1;
  }

  /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */
  function addClass(element, value) {
    if (!element || !value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        addClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.add(value);
      return;
    }
    var className = element.className.trim();
    if (!className) {
      element.className = value;
    } else if (className.indexOf(value) < 0) {
      element.className = "".concat(className, " ").concat(value);
    }
  }

  /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */
  function removeClass(element, value) {
    if (!element || !value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        removeClass(elem, value);
      });
      return;
    }
    if (element.classList) {
      element.classList.remove(value);
      return;
    }
    var className = element.className;
    if (className && className.indexOf(value) >= 0) {
      element.className = className.split(REGEXP_SPACES).filter(function (item) {
        return item && item !== value;
      }).join(' ');
    }
  }

  /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */
  function toggleClass(element, value, added) {
    if (!value) {
      return;
    }
    if (isNumber(element.length)) {
      forEach(element, function (elem) {
        toggleClass(elem, value, added);
      });
      return;
    }

    // IE10-11 doesn't support the second parameter of `classList.toggle`
    if (added) {
      addClass(element, value);
    } else {
      removeClass(element, value);
    }
  }
  var REGEXP_HYPHENATE = /([a-z\d])([A-Z])/g;

  /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */
  function hyphenate(value) {
    return value.replace(REGEXP_HYPHENATE, '$1-$2').toLowerCase();
  }

  /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */
  function getData(element, name) {
    if (isObject(element[name])) {
      return element[name];
    }
    if (element.dataset) {
      return element.dataset[name];
    }
    return element.getAttribute("data-".concat(hyphenate(name)));
  }

  /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */
  function setData(element, name, data) {
    if (isObject(data)) {
      element[name] = data;
    } else if (element.dataset) {
      element.dataset[name] = data;
    } else {
      element.setAttribute("data-".concat(hyphenate(name)), data);
    }
  }
  var onceSupported = function () {
    var supported = false;
    if (IS_BROWSER) {
      var once = false;
      var listener = function listener() {};
      var options = Object.defineProperty({}, 'once', {
        get: function get() {
          supported = true;
          return once;
        },
        /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */
        set: function set(value) {
          once = value;
        }
      });
      WINDOW.addEventListener('test', listener, options);
      WINDOW.removeEventListener('test', listener, options);
    }
    return supported;
  }();

  /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */
  function removeListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (!onceSupported) {
        var listeners = element.listeners;
        if (listeners && listeners[event] && listeners[event][listener]) {
          handler = listeners[event][listener];
          delete listeners[event][listener];
          if (Object.keys(listeners[event]).length === 0) {
            delete listeners[event];
          }
          if (Object.keys(listeners).length === 0) {
            delete element.listeners;
          }
        }
      }
      element.removeEventListener(event, handler, options);
    });
  }

  /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */
  function addListener(element, type, listener) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _handler = listener;
    type.trim().split(REGEXP_SPACES).forEach(function (event) {
      if (options.once && !onceSupported) {
        var _element$listeners = element.listeners,
          listeners = _element$listeners === void 0 ? {} : _element$listeners;
        _handler = function handler() {
          delete listeners[event][listener];
          element.removeEventListener(event, _handler, options);
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }
          listener.apply(element, args);
        };
        if (!listeners[event]) {
          listeners[event] = {};
        }
        if (listeners[event][listener]) {
          element.removeEventListener(event, listeners[event][listener], options);
        }
        listeners[event][listener] = _handler;
        element.listeners = listeners;
      }
      element.addEventListener(event, _handler, options);
    });
  }

  /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @param {Object} options - The additional event options.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */
  function dispatchEvent(element, type, data, options) {
    var event;

    // Event and CustomEvent on IE9-11 are global objects, not constructors
    if (isFunction(Event) && isFunction(CustomEvent)) {
      event = new CustomEvent(type, _objectSpread2({
        bubbles: true,
        cancelable: true,
        detail: data
      }, options));
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(type, true, true, data);
    }
    return element.dispatchEvent(event);
  }

  /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */
  function getOffset(element) {
    var box = element.getBoundingClientRect();
    return {
      left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
      top: box.top + (window.pageYOffset - document.documentElement.clientTop)
    };
  }

  /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */
  function getTransforms(_ref) {
    var rotate = _ref.rotate,
      scaleX = _ref.scaleX,
      scaleY = _ref.scaleY,
      translateX = _ref.translateX,
      translateY = _ref.translateY;
    var values = [];
    if (isNumber(translateX) && translateX !== 0) {
      values.push("translateX(".concat(translateX, "px)"));
    }
    if (isNumber(translateY) && translateY !== 0) {
      values.push("translateY(".concat(translateY, "px)"));
    }

    // Rotate should come first before scale to match orientation transform
    if (isNumber(rotate) && rotate !== 0) {
      values.push("rotate(".concat(rotate, "deg)"));
    }
    if (isNumber(scaleX) && isNumber(scaleY) && (scaleX !== 1 || scaleY !== 1)) {
      values.push("scaleX(".concat(scaleX, ")"));
      values.push("scaleY(".concat(scaleY, ")"));
    }
    var transform = values.length ? values.join(' ') : 'none';
    return {
      WebkitTransform: transform,
      msTransform: transform,
      transform: transform
    };
  }

  /**
   * Get an image name from an image url.
   * @param {string} url - The target url.
   * @example
   * // picture.jpg
   * getImageNameFromURL('https://domain.com/path/to/picture.jpg?size=1280×960')
   * @returns {string} A string contains the image name.
   */
  function getImageNameFromURL(url) {
    return isString(url) ? decodeURIComponent(url.replace(/^.*\//, '').replace(/[?&#].*$/, '')) : '';
  }
  var IS_SAFARI = WINDOW.navigator && /Version\/\d+(\.\d+)+?\s+Safari/i.test(WINDOW.navigator.userAgent);

  /**
   * Get an image's natural sizes.
   * @param {string} image - The target image.
   * @param {Object} options - The viewer options.
   * @param {Function} callback - The callback function.
   * @returns {HTMLImageElement} The new image.
   */
  function getImageNaturalSizes(image, options, callback) {
    var newImage = document.createElement('img');

    // Modern browsers (except Safari)
    if (image.naturalWidth && !IS_SAFARI) {
      callback(image.naturalWidth, image.naturalHeight);
      return newImage;
    }
    var body = document.body || document.documentElement;
    newImage.onload = function () {
      callback(newImage.width, newImage.height);
      if (!IS_SAFARI) {
        body.removeChild(newImage);
      }
    };
    inheritAttributes(newImage, image, options.inheritedAttributes);
    newImage.src = image.src;

    // iOS Safari will convert the image automatically
    // with its orientation once append it into DOM
    if (!IS_SAFARI) {
      newImage.style.cssText = 'left:0;' + 'max-height:none!important;' + 'max-width:none!important;' + 'min-height:0!important;' + 'min-width:0!important;' + 'opacity:0;' + 'position:absolute;' + 'top:0;' + 'z-index:-1;';
      body.appendChild(newImage);
    }
    return newImage;
  }

  /**
   * Get the related class name of a responsive type number.
   * @param {string} type - The responsive type.
   * @returns {string} The related class name.
   */
  function getResponsiveClass(type) {
    switch (type) {
      case 2:
        return CLASS_HIDE_XS_DOWN;
      case 3:
        return CLASS_HIDE_SM_DOWN;
      case 4:
        return CLASS_HIDE_MD_DOWN;
      default:
        return '';
    }
  }

  /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */
  function getMaxZoomRatio(pointers) {
    var pointers2 = _objectSpread2({}, pointers);
    var ratios = [];
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var x1 = Math.abs(pointer.startX - pointer2.startX);
        var y1 = Math.abs(pointer.startY - pointer2.startY);
        var x2 = Math.abs(pointer.endX - pointer2.endX);
        var y2 = Math.abs(pointer.endY - pointer2.endY);
        var z1 = Math.sqrt(x1 * x1 + y1 * y1);
        var z2 = Math.sqrt(x2 * x2 + y2 * y2);
        var ratio = (z2 - z1) / z1;
        ratios.push(ratio);
      });
    });
    ratios.sort(function (a, b) {
      return Math.abs(a) < Math.abs(b);
    });
    return ratios[0];
  }

  /**
   * Get the max rotation degree of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {number} The result degree.
   */
  function getMaxRotateDegree(pointers) {
    var pointers2 = _objectSpread2({}, pointers);
    var degrees = [];
    forEach(pointers, function (pointer, pointerId) {
      delete pointers2[pointerId];
      forEach(pointers2, function (pointer2) {
        var start = Math.atan2(pointer2.startY - pointer.startY, pointer2.startX - pointer.startX);
        var end = Math.atan2(pointer2.endY - pointer.endY, pointer2.endX - pointer.endX);
        var radians = end - start;
        if (radians > Math.PI) {
          radians -= Math.PI * 2;
        } else if (radians < -Math.PI) {
          radians += Math.PI * 2;
        }
        degrees.push(radians * 180 / Math.PI);
      });
    });
    degrees.sort(function (a, b) {
      return Math.abs(b) - Math.abs(a);
    });
    return degrees[0] || 0;
  }

  /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */
  function getPointer(_ref2, endOnly) {
    var pageX = _ref2.pageX,
      pageY = _ref2.pageY;
    var end = {
      endX: pageX,
      endY: pageY
    };
    return endOnly ? end : _objectSpread2({
      timeStamp: Date.now(),
      startX: pageX,
      startY: pageY
    }, end);
  }

  /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */
  function getPointersCenter(pointers) {
    var pageX = 0;
    var pageY = 0;
    var count = 0;
    forEach(pointers, function (_ref3) {
      var startX = _ref3.startX,
        startY = _ref3.startY;
      pageX += startX;
      pageY += startY;
      count += 1;
    });
    pageX /= count;
    pageY /= count;
    return {
      pageX: pageX,
      pageY: pageY
    };
  }

  var render = {
    render: function render() {
      this.initContainer();
      this.initViewer();
      this.initList();
      this.renderViewer();
    },
    initBody: function initBody() {
      var ownerDocument = this.ownerDocument;
      var body = ownerDocument.body || ownerDocument.documentElement;
      this.body = body;
      this.scrollbarWidth = window.innerWidth - ownerDocument.documentElement.clientWidth;
      this.initialBodyPaddingRight = body.style.paddingRight;
      this.initialBodyComputedPaddingRight = window.getComputedStyle(body).paddingRight;
    },
    initContainer: function initContainer() {
      this.containerData = {
        width: window.innerWidth,
        height: window.innerHeight
      };
    },
    initViewer: function initViewer() {
      var options = this.options,
        parent = this.parent;
      var viewerData;
      if (options.inline) {
        viewerData = {
          width: Math.max(parent.offsetWidth, options.minWidth),
          height: Math.max(parent.offsetHeight, options.minHeight)
        };
        this.parentData = viewerData;
      }
      if (this.fulled || !viewerData) {
        viewerData = this.containerData;
      }
      this.viewerData = assign({}, viewerData);
    },
    renderViewer: function renderViewer() {
      if (this.options.inline && !this.fulled) {
        setStyle(this.viewer, this.viewerData);
      }
    },
    initList: function initList() {
      var _this = this;
      var viewIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.index;
      var element = this.element,
        options = this.options,
        list = this.list;
      var items = [];
      var navbarOptions = isPlainObject(options.navbar) ? options.navbar : {};
      var probe = document.createElement('li');
      list.appendChild(probe);
      var itemWidth = probe.offsetWidth + parseInt(window.getComputedStyle(probe).marginLeft, 10);
      list.removeChild(probe);
      var visibleItemCount = isNumber(navbarOptions.visibleItemCount) ? Math.floor(navbarOptions.visibleItemCount) : Math.floor(this.containerData.width / itemWidth);
      visibleItemCount = Math.min(visibleItemCount, this.length);
      var start = visibleItemCount > 0 ? Math.min(Math.max(0, viewIndex - Math.floor(visibleItemCount / 2)), Math.max(0, this.length - visibleItemCount)) : 0;
      var end = visibleItemCount > 0 ? Math.min(this.length, start + visibleItemCount) : this.length;

      // initList may be called in this.update, so should keep idempotent
      list.innerHTML = '';
      forEach(this.images, function (image, index) {
        if (visibleItemCount > 0 && (index < start || index >= end)) {
          return;
        }
        var src = image.src;
        var alt = image.alt || getImageNameFromURL(src);
        var url = _this.getImageURL(image);
        if (src || url) {
          var item = document.createElement('li');
          var img = document.createElement('img');
          inheritAttributes(img, image, options.inheritedAttributes);
          if (options.navbar) {
            img.src = src || url;
          }
          img.alt = alt;
          img.setAttribute('data-original-url', url || src);
          item.setAttribute('data-index', index);
          item.setAttribute('data-viewer-action', 'view');
          item.setAttribute('role', 'button');
          if (options.keyboard) {
            item.setAttribute('tabindex', 0);
          }
          item.appendChild(img);
          list.appendChild(item);
          items.push(item);
        }
      });
      this.items = items;
      if (this.viewed) {
        var activeItem = this.getItem(this.index);
        if (activeItem) {
          addClass(activeItem, CLASS_ACTIVE);
          activeItem.setAttribute('aria-selected', true);
        }
      }
      forEach(items, function (item) {
        var image = item.firstElementChild;
        var onLoad;
        var onError;
        setData(image, 'filled', true);
        if (options.loading) {
          addClass(item, CLASS_LOADING);
        }
        addListener(image, EVENT_LOAD, onLoad = function onLoad(event) {
          removeListener(image, EVENT_ERROR, onError);
          if (options.loading) {
            removeClass(item, CLASS_LOADING);
          }
          _this.loadImage(event);
        }, {
          once: true
        });
        addListener(image, EVENT_ERROR, onError = function onError() {
          removeListener(image, EVENT_LOAD, onLoad);
          if (options.loading) {
            removeClass(item, CLASS_LOADING);
          }
        }, {
          once: true
        });
      });
      if (isTransitionEnabled(options, 'view')) {
        addListener(element, EVENT_VIEWED, function () {
          addClass(list, CLASS_TRANSITION);
        }, {
          once: true
        });
      }
    },
    getItem: function getItem(index) {
      var item;
      forEach(this.items, function (candidate) {
        if (Number(getData(candidate, 'index')) === index) {
          item = candidate;
          return false;
        }
        return true;
      });
      return item;
    },
    renderList: function renderList() {
      var index = this.index;
      var item = this.getItem(index);
      if (!item) {
        return;
      }
      var next = item.nextElementSibling;
      var gutter = parseInt(window.getComputedStyle(next || item).marginLeft, 10);
      var offsetWidth = item.offsetWidth;
      var outerWidth = offsetWidth + gutter;

      // Place the active item in the center of the screen
      setStyle(this.list, assign({
        width: outerWidth * this.items.length - gutter
      }, getTransforms({
        translateX: (this.viewerData.width - offsetWidth) / 2 - item.offsetLeft
      })));
    },
    resetList: function resetList() {
      var list = this.list;
      list.innerHTML = '';
      removeClass(list, CLASS_TRANSITION);
      setStyle(list, assign({
        width: 0
      }, getTransforms({
        translateX: 0
      })));
    },
    initImage: function initImage(done) {
      var _this2 = this;
      var options = this.options,
        image = this.image,
        viewerData = this.viewerData;
      var footerHeight = this.footer.offsetHeight;
      var viewerWidth = viewerData.width;
      var viewerHeight = Math.max(viewerData.height - footerHeight, footerHeight);
      var oldImageData = this.imageData || {};
      var sizingImage;
      this.imageInitializing = {
        abort: function abort() {
          sizingImage.onload = null;
        }
      };
      sizingImage = getImageNaturalSizes(image, options, function (naturalWidth, naturalHeight) {
        var aspectRatio = naturalWidth / naturalHeight;
        var initialCoverage = Math.max(0, Math.min(1, options.initialCoverage));
        var width = viewerWidth;
        var height = viewerHeight;
        _this2.imageInitializing = false;
        if (viewerHeight * aspectRatio > viewerWidth) {
          height = viewerWidth / aspectRatio;
        } else {
          width = viewerHeight * aspectRatio;
        }
        initialCoverage = isNumber(initialCoverage) ? initialCoverage : 0.9;
        width = Math.min(width * initialCoverage, naturalWidth);
        height = Math.min(height * initialCoverage, naturalHeight);
        var left = (viewerWidth - width) / 2;
        var top = (viewerHeight - height) / 2;
        var imageData = {
          left: left,
          top: top,
          x: left,
          y: top,
          width: width,
          height: height,
          oldRatio: 1,
          ratio: width / naturalWidth,
          aspectRatio: aspectRatio,
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight
        };
        var initialImageData = assign({}, imageData);
        if (options.rotatable) {
          imageData.rotate = oldImageData.rotate || 0;
          initialImageData.rotate = 0;
        }
        if (options.scalable) {
          imageData.scaleX = oldImageData.scaleX || 1;
          imageData.scaleY = oldImageData.scaleY || 1;
          initialImageData.scaleX = 1;
          initialImageData.scaleY = 1;
        }
        _this2.imageData = imageData;
        _this2.initialImageData = initialImageData;
        if (done) {
          done();
        }
      });
    },
    renderImage: function renderImage(done) {
      var _this3 = this;
      var image = this.image,
        imageData = this.imageData;
      setStyle(image, assign({
        width: imageData.width,
        height: imageData.height,
        // XXX: Not to use translateX/Y to avoid image shaking when zooming
        marginLeft: imageData.x,
        marginTop: imageData.y
      }, getTransforms(imageData)));
      if (this.magnifierPoint) {
        this.renderMagnifier();
      }
      if (done) {
        var action = false;
        if (this.viewing) {
          action = 'view';
        } else if (this.moving) {
          action = 'move';
        } else if (this.rotating) {
          action = 'rotate';
        } else if (this.scaling) {
          action = 'scale';
        } else if (this.zooming) {
          action = 'zoom';
        }
        if (action && isTransitionEnabled(this.options, action) && hasClass(image, CLASS_TRANSITION)) {
          var onTransitionEnd = function onTransitionEnd() {
            _this3.imageRendering = false;
            done();
          };
          this.imageRendering = {
            abort: function abort() {
              removeListener(image, EVENT_TRANSITION_END, onTransitionEnd);
            }
          };
          addListener(image, EVENT_TRANSITION_END, onTransitionEnd, {
            once: true
          });
        } else {
          done();
        }
      }
    },
    resetImage: function resetImage() {
      var image = this.image;
      if (image) {
        if (this.viewing) {
          this.viewing.abort();
        }
        image.parentNode.removeChild(image);
        this.image = null;
        this.title.innerHTML = '';
      }
    }
  };

  var events = {
    bind: function bind() {
      var options = this.options,
        viewer = this.viewer,
        canvas = this.canvas;
      var document = this.ownerDocument;
      addListener(viewer, EVENT_CLICK, this.onClick = this.click.bind(this));
      addListener(viewer, EVENT_DRAG_START, this.onDragStart = this.dragstart.bind(this));
      addListener(viewer, EVENT_POINTER_ENTER, this.onMagnifyEnter = this.magnify.bind(this));
      addListener(viewer, EVENT_POINTER_MOVE, this.onMagnify = this.magnify.bind(this));
      addListener(viewer, EVENT_POINTER_LEAVE, this.onMagnifierLeave = this.hideMagnifier.bind(this));
      addListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown = this.pointerdown.bind(this));
      addListener(document, EVENT_POINTER_MOVE, this.onPointerMove = this.pointermove.bind(this));
      addListener(document, EVENT_POINTER_UP, this.onPointerUp = this.pointerup.bind(this));
      addListener(document, EVENT_KEY_DOWN, this.onKeyDown = this.keydown.bind(this));
      addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
      if (options.zoomable && options.zoomOnWheel) {
        addListener(viewer, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
          passive: false,
          capture: true
        });
      }
      if (options.zoomable && options.zoomOnGesture || options.rotatable && options.rotateOnGesture) {
        addListener(viewer, EVENT_GESTURE, this.onGesture = this.gesture.bind(this), {
          passive: false
        });
      }
      if (options.toggleOnDblclick) {
        addListener(canvas, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
      }
    },
    unbind: function unbind() {
      var options = this.options,
        viewer = this.viewer,
        canvas = this.canvas;
      var document = this.ownerDocument;
      removeListener(viewer, EVENT_CLICK, this.onClick);
      removeListener(viewer, EVENT_DRAG_START, this.onDragStart);
      removeListener(viewer, EVENT_POINTER_ENTER, this.onMagnifyEnter);
      removeListener(viewer, EVENT_POINTER_MOVE, this.onMagnify);
      removeListener(viewer, EVENT_POINTER_LEAVE, this.onMagnifierLeave);
      removeListener(canvas, EVENT_POINTER_DOWN, this.onPointerDown);
      removeListener(document, EVENT_POINTER_MOVE, this.onPointerMove);
      removeListener(document, EVENT_POINTER_UP, this.onPointerUp);
      removeListener(document, EVENT_KEY_DOWN, this.onKeyDown);
      removeListener(window, EVENT_RESIZE, this.onResize);
      if (options.zoomable && options.zoomOnWheel) {
        removeListener(viewer, EVENT_WHEEL, this.onWheel, {
          passive: false,
          capture: true
        });
      }
      if (options.zoomable && options.zoomOnGesture || options.rotatable && options.rotateOnGesture) {
        removeListener(viewer, EVENT_GESTURE, this.onGesture, {
          passive: false
        });
      }
      if (options.toggleOnDblclick) {
        removeListener(canvas, EVENT_DBLCLICK, this.onDblclick);
      }
    }
  };

  var handlers = {
    click: function click(event) {
      var options = this.options,
        imageData = this.imageData;
      var target = event.target;
      var action = getData(target, DATA_ACTION);
      if (!action && target.localName === 'img' && target.parentElement.localName === 'li') {
        target = target.parentElement;
        action = getData(target, DATA_ACTION);
      }

      // Cancel the emulated click when the native click event was triggered.
      if (IS_TOUCH_DEVICE && event.isTrusted && target === this.canvas) {
        clearTimeout(this.clickCanvasTimeout);
      }
      switch (action) {
        case 'mix':
          if (this.played) {
            this.stop();
          } else if (options.inline) {
            if (this.fulled) {
              this.exit();
            } else {
              this.full();
            }
          } else {
            this.hide();
          }
          break;
        case 'hide':
          if (!this.pointerMoved) {
            this.hide();
          }
          break;
        case 'view':
          this.view(getData(target, 'index'));
          break;
        case 'zoom-in':
          this.zoom(0.1, true);
          break;
        case 'zoom-out':
          this.zoom(-0.1, true);
          break;
        case 'one-to-one':
          this.toggle();
          break;
        case 'reset':
          this.reset();
          break;
        case 'prev':
          this.prev(options.loop);
          break;
        case 'play':
          this.play(options.fullscreen);
          break;
        case 'next':
          this.next(options.loop);
          break;
        case 'rotate-left':
          this.rotate(-90);
          break;
        case 'rotate-right':
          this.rotate(90);
          break;
        case 'flip-horizontal':
          this.scaleX(-imageData.scaleX || -1);
          break;
        case 'flip-vertical':
          this.scaleY(-imageData.scaleY || -1);
          break;
        default:
          if (this.played) {
            this.stop();
          }
      }
    },
    dblclick: function dblclick(event) {
      event.preventDefault();
      if (this.viewed && event.target === this.image) {
        // Cancel the emulated double click when the native dblclick event was triggered.
        if (IS_TOUCH_DEVICE && event.isTrusted) {
          clearTimeout(this.doubleClickImageTimeout);
        }

        // XXX: No pageX/Y properties in custom event, fallback to the original event.
        this.toggle(event.isTrusted ? event : event.detail && event.detail.originalEvent);
      }
    },
    load: function load() {
      var _this = this;
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = false;
      }
      var element = this.element,
        options = this.options,
        image = this.image,
        index = this.index,
        viewerData = this.viewerData;
      removeClass(image, CLASS_INVISIBLE);
      if (options.loading) {
        removeClass(this.canvas, CLASS_LOADING);
      }
      image.style.cssText = 'height:0;' + "margin-left:".concat(viewerData.width / 2, "px;") + "margin-top:".concat(viewerData.height / 2, "px;") + 'max-width:none!important;' + 'position:relative;' + 'width:0;';
      this.initImage(function () {
        toggleClass(image, CLASS_MOVE, options.movable);
        toggleClass(image, CLASS_TRANSITION, isTransitionEnabled(options, 'view'));
        _this.renderImage(function () {
          _this.viewed = true;
          _this.viewing = false;
          setTimeout(function () {
            toggleClass(image, CLASS_TRANSITION, options.transition);
          }, 300);
          if (isFunction(options.viewed)) {
            addListener(element, EVENT_VIEWED, options.viewed, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_VIEWED, {
            originalImage: _this.images[index],
            index: index,
            image: image
          }, {
            cancelable: false
          });
        });
      });
    },
    loadImage: function loadImage(event) {
      var image = event.target;
      var parent = image.parentNode;
      var parentWidth = parent.offsetWidth || 30;
      var parentHeight = parent.offsetHeight || 50;
      var filled = !!getData(image, 'filled');
      getImageNaturalSizes(image, this.options, function (naturalWidth, naturalHeight) {
        var aspectRatio = naturalWidth / naturalHeight;
        var width = parentWidth;
        var height = parentHeight;
        if (parentHeight * aspectRatio > parentWidth) {
          if (filled) {
            width = parentHeight * aspectRatio;
          } else {
            height = parentWidth / aspectRatio;
          }
        } else if (filled) {
          height = parentWidth / aspectRatio;
        } else {
          width = parentHeight * aspectRatio;
        }
        setStyle(image, assign({
          width: width,
          height: height
        }, getTransforms({
          translateX: (parentWidth - width) / 2,
          translateY: (parentHeight - height) / 2
        })));
      });
    },
    keydown: function keydown(event) {
      var options = this.options;
      if (!options.keyboard) {
        return;
      }
      var keyCode = event.keyCode || event.which || event.charCode;
      switch (keyCode) {
        // Enter
        case 13:
          if (this.viewer.contains(event.target)) {
            this.click(event);
          }
          break;
      }
      if (!this.fulled) {
        return;
      }
      switch (keyCode) {
        // Escape
        case 27:
          if (this.played) {
            this.stop();
          } else if (options.inline) {
            if (this.fulled) {
              this.exit();
            }
          } else {
            this.hide();
          }
          break;

        // Space
        case 32:
          if (this.played) {
            this.stop();
          }
          break;

        // ArrowLeft
        case 37:
          if (this.played && this.playing) {
            this.playing.prev();
          } else {
            this.prev(options.loop);
          }
          break;

        // ArrowUp
        case 38:
          // Prevent scroll on Firefox
          event.preventDefault();

          // Zoom in
          this.zoom(options.zoomRatio, true);
          break;

        // ArrowRight
        case 39:
          if (this.played && this.playing) {
            this.playing.next();
          } else {
            this.next(options.loop);
          }
          break;

        // ArrowDown
        case 40:
          // Prevent scroll on Firefox
          event.preventDefault();

          // Zoom out
          this.zoom(-options.zoomRatio, true);
          break;

        // Ctrl + 0
        case 48:
        // Fall through

        // Ctrl + 1
        // eslint-disable-next-line no-fallthrough
        case 49:
          if (event.ctrlKey) {
            event.preventDefault();
            this.toggle();
          }
          break;
      }
    },
    dragstart: function dragstart(event) {
      if (event.target.localName === 'img') {
        event.preventDefault();
      }
    },
    magnify: function magnify(event) {
      if (event.changedTouches || event.pointerType && event.pointerType !== 'mouse') {
        this.hideMagnifier();
        return;
      }
      this.magnifierPoint = {
        clientX: event.clientX,
        clientY: event.clientY
      };
      this.renderMagnifier();
    },
    renderMagnifier: function renderMagnifier() {
      var options = this.options,
        imageData = this.imageData,
        magnifier = this.magnifier,
        magnifierImage = this.magnifierImage,
        viewer = this.viewer;
      var config = isPlainObject(options.magnifier) ? options.magnifier : {};
      var point = this.magnifierPoint;
      if (!options.magnifier || !this.fulled || !this.viewed || !magnifier || !magnifierImage || !point) {
        this.hideMagnifier();
        return;
      }
      var size = Math.max(1, Number(config.size) || 100);
      var zoomRatio = Math.max(1, Number(config.zoomRatio) || 2);
      var opacity = Number(config.opacity);
      var rect = viewer.getBoundingClientRect();
      var x = point.clientX - rect.left;
      var y = point.clientY - rect.top;
      var imageURL = this.image.currentSrc || this.image.src;
      var imageRect = this.image.getBoundingClientRect();
      if (point.clientX < imageRect.left || point.clientX > imageRect.right || point.clientY < imageRect.top || point.clientY > imageRect.bottom) {
        this.hideMagnifier();
        return;
      }
      var scaleX = isNumber(imageData.scaleX) ? imageData.scaleX : 1;
      var scaleY = isNumber(imageData.scaleY) ? imageData.scaleY : 1;
      var rotate = (imageData.rotate || 0) * Math.PI / 180;
      var cos = Math.cos(rotate);
      var sin = Math.sin(rotate);
      var matrixA = cos * scaleX;
      var matrixB = sin * scaleX;
      var matrixC = -sin * scaleY;
      var matrixD = cos * scaleY;
      var determinant = scaleX * scaleY;
      if (determinant === 0) {
        this.hideMagnifier();
        return;
      }
      var centerX = imageData.x + imageData.width / 2;
      var centerY = imageData.y + imageData.height / 2;
      var localX = (matrixD * (x - centerX) - matrixC * (y - centerY)) / determinant;
      var localY = (-matrixB * (x - centerX) + matrixA * (y - centerY)) / determinant;
      var sourceX = localX + imageData.width / 2;
      var sourceY = localY + imageData.height / 2;
      var magnifiedWidth = imageData.width * zoomRatio;
      var magnifiedHeight = imageData.height * zoomRatio;
      var transformedX = matrixA * (sourceX * zoomRatio - magnifiedWidth / 2) + matrixC * (sourceY * zoomRatio - magnifiedHeight / 2);
      var transformedY = matrixB * (sourceX * zoomRatio - magnifiedWidth / 2) + matrixD * (sourceY * zoomRatio - magnifiedHeight / 2);
      this.magnifierSourcePoint = {
        x: sourceX,
        y: sourceY
      };
      magnifier.style.width = "".concat(size, "px");
      magnifier.style.height = "".concat(size, "px");
      magnifier.style.opacity = "".concat(Math.max(0, Math.min(1, isNumber(opacity) ? opacity : 1)));
      magnifierImage.src = imageURL;
      magnifierImage.style.width = "".concat(magnifiedWidth, "px");
      magnifierImage.style.height = "".concat(magnifiedHeight, "px");
      magnifierImage.style.left = "".concat(size / 2 - magnifiedWidth / 2 - transformedX, "px");
      magnifierImage.style.top = "".concat(size / 2 - magnifiedHeight / 2 - transformedY, "px");
      magnifierImage.style.transform = "rotate(".concat(imageData.rotate || 0, "deg) scaleX(").concat(scaleX, ") scaleY(").concat(scaleY, ")");
      magnifier.removeAttribute('aria-hidden');
      addClass(magnifier, 'viewer-show');
    },
    hideMagnifier: function hideMagnifier() {
      if (this.magnifier) {
        removeClass(this.magnifier, 'viewer-show');
        this.magnifier.setAttribute('aria-hidden', true);
        this.magnifierPoint = null;
      }
    },
    pointerdown: function pointerdown(event) {
      var options = this.options,
        pointers = this.pointers;
      var buttons = event.buttons,
        button = event.button;
      this.pointerMoved = false;
      if (!this.viewed || this.showing || this.viewing || this.hiding

      // Handle mouse event and pointer event and ignore touch event
      || (event.type === 'mousedown' || event.type === 'pointerdown' && event.pointerType === 'mouse') && (
      // No primary button (Usually the left button)
      isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0

      // Open context menu
      || event.ctrlKey)) {
        return;
      }

      // Prevent default behaviours as page zooming in touch devices.
      event.preventDefault();
      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          pointers[touch.identifier] = getPointer(touch);
        });
      } else {
        pointers[event.pointerId || 0] = getPointer(event);
      }
      var action = options.movable ? ACTION_MOVE : false;
      if ((options.zoomable && options.zoomOnTouch || options.rotatable && options.rotateOnTouch) && Object.keys(pointers).length > 1) {
        // action = ACTION_ZOOM;
        // action = ACTION_ROTATE;
        action = ACTION_TRANSFORM;
      } else if (options.slideOnTouch && (event.pointerType === 'touch' || event.type === 'touchstart') && this.isSwitchable()) {
        action = ACTION_SWITCH;
      }
      if (action === ACTION_MOVE || action === ACTION_ZOOM || action === ACTION_ROTATE || action === ACTION_TRANSFORM) {
        removeClass(this.image, CLASS_TRANSITION);
      }
      this.action = action;
    },
    pointermove: function pointermove(event) {
      var pointers = this.pointers,
        action = this.action;
      if (!this.viewed || !action) {
        return;
      }
      event.preventDefault();
      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          assign(pointers[touch.identifier] || {}, getPointer(touch, true));
        });
      } else {
        assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
      }
      this.change(event);
    },
    pointerup: function pointerup(event) {
      var _this2 = this;
      var options = this.options,
        action = this.action,
        pointers = this.pointers;
      var pointer;
      if (event.changedTouches) {
        forEach(event.changedTouches, function (touch) {
          pointer = pointers[touch.identifier];
          delete pointers[touch.identifier];
        });
      } else {
        pointer = pointers[event.pointerId || 0];
        delete pointers[event.pointerId || 0];
      }
      if (!action) {
        return;
      }
      event.preventDefault();
      if (action === ACTION_MOVE || action === ACTION_ZOOM || action === ACTION_ROTATE || action === ACTION_TRANSFORM) {
        var transition = action === ACTION_TRANSFORM ? isTransitionEnabled(options, ACTION_ZOOM) || isTransitionEnabled(options, ACTION_ROTATE) : isTransitionEnabled(options, action);
        toggleClass(this.image, CLASS_TRANSITION, transition);
      }
      this.action = false;

      // Emulate click and double click in touch devices to support backdrop and image zooming (#210).
      if (IS_TOUCH_DEVICE && action !== ACTION_ZOOM && action !== ACTION_TRANSFORM && pointer && Date.now() - pointer.timeStamp < 500) {
        clearTimeout(this.clickCanvasTimeout);
        clearTimeout(this.doubleClickImageTimeout);
        if (options.toggleOnDblclick && this.viewed && event.target === this.image) {
          if (this.pointerMoved) {
            this.imageClicked = false;
          } else if (this.imageClicked) {
            this.imageClicked = false;

            // This timeout will be cleared later when a native dblclick event is triggering
            this.doubleClickImageTimeout = setTimeout(function () {
              dispatchEvent(_this2.image, EVENT_DBLCLICK, {
                originalEvent: event
              });
            }, 50);
          } else {
            this.imageClicked = true;

            // The default timing of a double click in Windows is 500 ms
            this.doubleClickImageTimeout = setTimeout(function () {
              _this2.imageClicked = false;
            }, 500);
          }
        } else {
          this.imageClicked = false;
          if (options.backdrop && options.backdrop !== 'static' && event.target === this.canvas) {
            // This timeout will be cleared later when a native click event is triggering
            this.clickCanvasTimeout = setTimeout(function () {
              dispatchEvent(_this2.canvas, EVENT_CLICK, {
                originalEvent: event
              });
            }, 50);
          }
        }
      }
    },
    resize: function resize() {
      var _this3 = this;
      if (!this.isShown || this.hiding) {
        return;
      }
      if (this.fulled) {
        this.close();
        this.initBody();
        this.open();
      }
      this.initContainer();
      this.initViewer();
      this.renderViewer();
      var navbarOptions = isPlainObject(this.options.navbar) ? this.options.navbar : {};
      if (isUndefined(navbarOptions.visibleItemCount)) {
        this.initList(this.index);
      }
      this.renderList();
      if (this.viewed) {
        this.initImage(function () {
          _this3.renderImage();
        });
      }
      if (this.played) {
        if (this.options.fullscreen && this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
          this.stop();
          return;
        }
        forEach(this.player.getElementsByTagName('img'), function (image) {
          addListener(image, EVENT_LOAD, _this3.loadImage.bind(_this3), {
            once: true
          });
          dispatchEvent(image, EVENT_LOAD);
        });
      }
    },
    wheel: function wheel(event) {
      var _this4 = this;
      if (!this.viewed) {
        return;
      }
      event.preventDefault();
      if (this.gesturing) {
        return;
      }

      // Limit wheel speed to prevent zoom too fast
      if (this.wheeling) {
        return;
      }
      this.wheeling = true;
      setTimeout(function () {
        _this4.wheeling = false;
      }, 50);
      var ratio = Number(this.options.zoomRatio) || 0.1;
      var delta = 1;
      if (event.deltaY) {
        delta = event.deltaY > 0 ? 1 : -1;
      } else if (event.wheelDelta) {
        delta = -event.wheelDelta / 120;
      } else if (event.detail) {
        delta = event.detail > 0 ? 1 : -1;
      }
      this.zoom(-delta * ratio, true, null, event);
    },
    gesture: function gesture(event) {
      var options = this.options;
      if (!this.viewed || !options.zoomOnGesture && !options.rotateOnGesture) {
        return;
      }
      event.preventDefault();
      switch (event.type) {
        case 'gesturestart':
          this.gesturing = true;
          this.gestureScale = event.scale || 1;
          this.gestureRotation = event.rotation || 0;
          break;
        case 'gesturechange':
          {
            var scale = event.scale || 1;
            var ratio = scale / (this.gestureScale || 1);
            var rotation = Number(event.rotation);
            var degree = rotation - (this.gestureRotation || 0);
            this.gestureScale = scale;
            if (options.zoomable && options.zoomOnGesture && ratio !== 1) {
              this.zoom(ratio >= 1 ? ratio - 1 : 1 - 1 / ratio, false, null, event);
            }
            if (options.rotatable && options.rotateOnGesture && isNumber(rotation)) {
              this.gestureRotation = rotation;
              if (degree !== 0) {
                this.rotate(degree);
              }
            }
            break;
          }
        case 'gestureend':
          this.gesturing = false;
          this.gestureScale = 1;
          this.gestureRotation = 0;
          break;
      }
    }
  };

  var methods = {
    /** Show the viewer (only available in modal mode)
     * @param {boolean} [immediate=false] - Indicates if show the viewer immediately or not.
     * @returns {Viewer} this
     */
    show: function show() {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var element = this.element,
        options = this.options;
      if (options.inline || this.showing || this.isShown || this.showing) {
        return this;
      }
      if (!this.ready) {
        this.build();
        if (this.ready) {
          this.show(immediate);
        }
        return this;
      }
      if (isFunction(options.show)) {
        addListener(element, EVENT_SHOW, options.show, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_SHOW) === false || !this.ready) {
        return this;
      }
      if (this.hiding) {
        this.transitioning.abort();
      }
      this.showing = true;
      this.open();
      var viewer = this.viewer;
      removeClass(viewer, CLASS_HIDE);
      viewer.setAttribute('role', 'dialog');
      viewer.setAttribute('aria-labelledby', this.title.id);
      viewer.setAttribute('aria-modal', true);
      viewer.removeAttribute('aria-hidden');
      if (isTransitionEnabled(options, 'show') && !immediate) {
        var shown = this.shown.bind(this);
        this.transitioning = {
          abort: function abort() {
            removeListener(viewer, EVENT_TRANSITION_END, shown);
            removeClass(viewer, CLASS_IN);
          }
        };
        addClass(viewer, CLASS_TRANSITION);

        // Force reflow to enable CSS3 transition
        viewer.initialOffsetWidth = viewer.offsetWidth;
        addListener(viewer, EVENT_TRANSITION_END, shown, {
          once: true
        });
        addClass(viewer, CLASS_IN);
      } else {
        addClass(viewer, CLASS_IN);
        this.shown();
      }
      return this;
    },
    /**
     * Hide the viewer (only available in modal mode)
     * @param {boolean} [immediate=false] - Indicates if hide the viewer immediately or not.
     * @returns {Viewer} this
     */
    hide: function hide() {
      var _this = this;
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var element = this.element,
        options = this.options;
      if (options.inline || this.hiding || !(this.isShown || this.showing)) {
        return this;
      }
      if (isFunction(options.hide)) {
        addListener(element, EVENT_HIDE, options.hide, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_HIDE) === false || this.destroyed) {
        return this;
      }
      if (this.showing) {
        this.transitioning.abort();
      }
      this.hiding = true;
      if (this.played) {
        this.stop();
      } else if (this.viewing) {
        this.viewing.abort();
      }
      var viewer = this.viewer,
        image = this.image;
      var hideImmediately = function hideImmediately() {
        removeClass(viewer, CLASS_IN);
        _this.hidden();
      };
      if (isTransitionEnabled(options, 'hide') && !immediate) {
        var _onViewerTransitionEnd = function onViewerTransitionEnd(event) {
          // Ignore all propagating `transitionend` events (#275).
          if (event && event.target === viewer) {
            removeListener(viewer, EVENT_TRANSITION_END, _onViewerTransitionEnd);
            _this.hidden();
          }
        };
        var onImageTransitionEnd = function onImageTransitionEnd() {
          // In case of show the viewer by `viewer.show(true)` previously (#407).
          if (hasClass(viewer, CLASS_TRANSITION)) {
            addListener(viewer, EVENT_TRANSITION_END, _onViewerTransitionEnd);
            removeClass(viewer, CLASS_IN);
          } else {
            hideImmediately();
          }
        };
        this.transitioning = {
          abort: function abort() {
            if (_this.viewed && hasClass(image, CLASS_TRANSITION)) {
              removeListener(image, EVENT_TRANSITION_END, onImageTransitionEnd);
            } else if (hasClass(viewer, CLASS_TRANSITION)) {
              removeListener(viewer, EVENT_TRANSITION_END, _onViewerTransitionEnd);
            }
          }
        };

        // In case of hiding the viewer when holding on the image (#255),
        // note that the `CLASS_TRANSITION` class will be removed on pointer down.
        if (this.viewed && hasClass(image, CLASS_TRANSITION)) {
          addListener(image, EVENT_TRANSITION_END, onImageTransitionEnd, {
            once: true
          });
          this.zoomTo(0, false, null, null, true);
        } else {
          onImageTransitionEnd();
        }
      } else {
        hideImmediately();
      }
      return this;
    },
    /**
     * View one of the images with image's index
     * @param {number} index - The index of the image to view.
     * @returns {Viewer} this
     */
    view: function view() {
      var _this2 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.initialViewIndex;
      var previousIndex = this.index;
      index = Number(index) || 0;
      if (this.hiding || this.played || index < 0 || index >= this.length || this.viewed && index === previousIndex) {
        return this;
      }
      if (!this.isShown) {
        this.index = index;
        return this.show();
      }
      if (this.viewing) {
        this.viewing.abort();
      }
      var element = this.element,
        options = this.options,
        title = this.title,
        canvas = this.canvas;
      var item = this.getItem(index);
      if (!item) {
        this.initList(index);
        item = this.getItem(index);
      }
      var img = item.querySelector('img');
      var url = getData(img, 'originalUrl');
      var alt = img.getAttribute('alt');
      var image = document.createElement('img');
      inheritAttributes(image, img, options.inheritedAttributes);
      image.src = url;
      image.alt = alt;
      if (isFunction(options.view)) {
        addListener(element, EVENT_VIEW, options.view, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_VIEW, {
        originalImage: this.images[index],
        index: index,
        image: image
      }) === false || !this.isShown || this.hiding || this.played) {
        return this;
      }
      this.hideMagnifier();
      var activeItem = this.getItem(previousIndex);
      if (activeItem) {
        removeClass(activeItem, CLASS_ACTIVE);
        activeItem.removeAttribute('aria-selected');
      }
      addClass(item, CLASS_ACTIVE);
      item.setAttribute('aria-selected', true);
      if (options.focus) {
        item.focus();
      }
      this.image = image;
      this.viewed = false;
      this.index = index;
      this.imageData = {};
      addClass(image, CLASS_INVISIBLE);
      if (options.loading) {
        addClass(canvas, CLASS_LOADING);
      }
      canvas.innerHTML = '';
      canvas.appendChild(image);

      // Center current item
      this.renderList();

      // Clear title
      title.innerHTML = '';

      // Generate title after viewed
      var onViewed = function onViewed() {
        var imageData = _this2.imageData;
        var render = Array.isArray(options.title) ? options.title[1] : options.title;
        title.innerHTML = escapeHTMLEntities(isFunction(render) ? render.call(_this2, image, imageData) : "".concat(alt, " (").concat(imageData.naturalWidth, " \xD7 ").concat(imageData.naturalHeight, ")"));

        // Preload the image in the direction of navigation
        if (options.preload) {
          var direction = index < previousIndex ? -1 : 1;
          var nextIndex = index + direction;
          if (nextIndex < 0 || nextIndex >= _this2.length) {
            if (options.loop) {
              nextIndex = direction > 0 ? 0 : _this2.length - 1;
            } else {
              nextIndex = -1;
            }
          }
          if (nextIndex !== index) {
            var nextImage = _this2.images[nextIndex];
            var preloadedImage = document.createElement('img');
            inheritAttributes(preloadedImage, nextImage, options.inheritedAttributes);
            preloadedImage.src = _this2.getImageURL(nextImage) || nextImage.src;
          }
        }
      };
      var onLoad;
      var onError;
      addListener(element, EVENT_VIEWED, onViewed, {
        once: true
      });
      this.viewing = {
        abort: function abort() {
          removeListener(element, EVENT_VIEWED, onViewed);
          if (image.complete) {
            if (_this2.imageRendering) {
              _this2.imageRendering.abort();
            } else if (_this2.imageInitializing) {
              _this2.imageInitializing.abort();
            }
          } else {
            // Cancel download to save bandwidth.
            image.src = '';
            removeListener(image, EVENT_LOAD, onLoad);
            if (_this2.timeout) {
              clearTimeout(_this2.timeout);
            }
          }
        }
      };
      if (image.complete) {
        this.load();
      } else {
        addListener(image, EVENT_LOAD, onLoad = function onLoad() {
          removeListener(image, EVENT_ERROR, onError);
          _this2.load();
        }, {
          once: true
        });
        addListener(image, EVENT_ERROR, onError = function onError() {
          removeListener(image, EVENT_LOAD, onLoad);
          if (_this2.timeout) {
            clearTimeout(_this2.timeout);
            _this2.timeout = false;
          }
          removeClass(image, CLASS_INVISIBLE);
          if (options.loading) {
            removeClass(_this2.canvas, CLASS_LOADING);
          }
        }, {
          once: true
        });
        if (this.timeout) {
          clearTimeout(this.timeout);
        }

        // Make the image visible if it fails to load within 1s
        this.timeout = setTimeout(function () {
          removeClass(image, CLASS_INVISIBLE);
          _this2.timeout = false;
        }, 1000);
      }
      return this;
    },
    /**
     * View the previous image
     * @param {boolean} [loop=false] - Indicate if view the last one
     * when it is the first one at present.
     * @returns {Viewer} this
     */
    prev: function prev() {
      var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var index = this.index - 1;
      if (index < 0) {
        index = loop ? this.length - 1 : 0;
      }
      this.view(index);
      return this;
    },
    /**
     * View the next image
     * @param {boolean} [loop=false] - Indicate if view the first one
     * when it is the last one at present.
     * @returns {Viewer} this
     */
    next: function next() {
      var loop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var maxIndex = this.length - 1;
      var index = this.index + 1;
      if (index > maxIndex) {
        index = loop ? 0 : maxIndex;
      }
      this.view(index);
      return this;
    },
    /**
     * Move the image with relative offsets.
     * @param {number} x - The moving distance in the horizontal direction.
     * @param {number} [y=x] The moving distance in the vertical direction.
     * @returns {Viewer} this
     */
    move: function move(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var imageData = this.imageData;
      this.moveTo(isUndefined(x) ? x : imageData.x + Number(x), isUndefined(y) ? y : imageData.y + Number(y));
      return this;
    },
    /**
     * Move the image to an absolute point.
     * @param {number} x - The new position in the horizontal direction.
     * @param {number} [y=x] - The new position in the vertical direction.
     * @param {Event} [_originalEvent=null] - The original event if any.
     * @returns {Viewer} this
     */
    moveTo: function moveTo(x) {
      var _this3 = this;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
      var _originalEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var element = this.element,
        options = this.options,
        imageData = this.imageData;
      x = Number(x);
      y = Number(y);
      if (this.viewed && !this.played && options.movable) {
        var oldX = imageData.x;
        var oldY = imageData.y;
        var changed = false;
        if (isNumber(x)) {
          changed = true;
        } else {
          x = oldX;
        }
        if (isNumber(y)) {
          changed = true;
        } else {
          y = oldY;
        }
        if (changed) {
          if (isFunction(options.move)) {
            addListener(element, EVENT_MOVE, options.move, {
              once: true
            });
          }
          if (dispatchEvent(element, EVENT_MOVE, {
            x: x,
            y: y,
            oldX: oldX,
            oldY: oldY,
            originalEvent: _originalEvent
          }) === false) {
            return this;
          }
          imageData.x = x;
          imageData.y = y;
          imageData.left = x;
          imageData.top = y;
          toggleClass(this.image, CLASS_TRANSITION, isTransitionEnabled(options, 'move'));
          this.moving = true;
          this.renderImage(function () {
            _this3.moving = false;
            if (isFunction(options.moved)) {
              addListener(element, EVENT_MOVED, options.moved, {
                once: true
              });
            }
            dispatchEvent(element, EVENT_MOVED, {
              x: x,
              y: y,
              oldX: oldX,
              oldY: oldY,
              originalEvent: _originalEvent
            }, {
              cancelable: false
            });
          });
        }
      }
      return this;
    },
    /**
     * Rotate the image with a relative degree.
     * @param {number} degree - The rotate degree.
     * @returns {Viewer} this
     */
    rotate: function rotate(degree) {
      this.rotateTo((this.imageData.rotate || 0) + Number(degree));
      return this;
    },
    /**
     * Rotate the image to an absolute degree.
     * @param {number} degree - The rotate degree.
     * @returns {Viewer} this
     */
    rotateTo: function rotateTo(degree) {
      var _this4 = this;
      var element = this.element,
        options = this.options,
        imageData = this.imageData;
      degree = Number(degree);
      if (isNumber(degree) && this.viewed && !this.played && options.rotatable) {
        var oldDegree = imageData.rotate;
        if (isFunction(options.rotate)) {
          addListener(element, EVENT_ROTATE, options.rotate, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_ROTATE, {
          degree: degree,
          oldDegree: oldDegree
        }) === false) {
          return this;
        }
        imageData.rotate = degree;
        toggleClass(this.image, CLASS_TRANSITION, isTransitionEnabled(options, 'rotate'));
        this.rotating = true;
        this.renderImage(function () {
          _this4.rotating = false;
          if (isFunction(options.rotated)) {
            addListener(element, EVENT_ROTATED, options.rotated, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_ROTATED, {
            degree: degree,
            oldDegree: oldDegree
          }, {
            cancelable: false
          });
        });
      }
      return this;
    },
    /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Viewer} this
     */
    scaleX: function scaleX(_scaleX) {
      this.scale(_scaleX, this.imageData.scaleY);
      return this;
    },
    /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Viewer} this
     */
    scaleY: function scaleY(_scaleY) {
      this.scale(this.imageData.scaleX, _scaleY);
      return this;
    },
    /**
     * Scale the image.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Viewer} this
     */
    scale: function scale(scaleX) {
      var _this5 = this;
      var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
      var element = this.element,
        options = this.options,
        imageData = this.imageData;
      scaleX = Number(scaleX);
      scaleY = Number(scaleY);
      if (this.viewed && !this.played && options.scalable) {
        var oldScaleX = imageData.scaleX;
        var oldScaleY = imageData.scaleY;
        var changed = false;
        if (isNumber(scaleX)) {
          changed = true;
        } else {
          scaleX = oldScaleX;
        }
        if (isNumber(scaleY)) {
          changed = true;
        } else {
          scaleY = oldScaleY;
        }
        if (changed) {
          if (isFunction(options.scale)) {
            addListener(element, EVENT_SCALE, options.scale, {
              once: true
            });
          }
          if (dispatchEvent(element, EVENT_SCALE, {
            scaleX: scaleX,
            scaleY: scaleY,
            oldScaleX: oldScaleX,
            oldScaleY: oldScaleY
          }) === false) {
            return this;
          }
          imageData.scaleX = scaleX;
          imageData.scaleY = scaleY;
          toggleClass(this.image, CLASS_TRANSITION, isTransitionEnabled(options, 'scale'));
          this.scaling = true;
          this.renderImage(function () {
            _this5.scaling = false;
            if (isFunction(options.scaled)) {
              addListener(element, EVENT_SCALED, options.scaled, {
                once: true
              });
            }
            dispatchEvent(element, EVENT_SCALED, {
              scaleX: scaleX,
              scaleY: scaleY,
              oldScaleX: oldScaleX,
              oldScaleY: oldScaleY
            }, {
              cancelable: false
            });
          });
        }
      }
      return this;
    },
    /**
     * Zoom the image with a relative ratio.
     * @param {number} ratio - The target ratio.
     * @param {boolean} [showTooltip=false] - Indicates whether to show the tooltip.
     * @param {Object} [pivot] - The pivot point coordinate for zooming.
     * @param {Event} [_originalEvent=null] - The original event if any.
     * @returns {Viewer} this
     */
    zoom: function zoom(ratio) {
      var showTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var pivot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _originalEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var imageData = this.imageData;
      ratio = Number(ratio);
      if (ratio < 0) {
        ratio = 1 / (1 - ratio);
      } else {
        ratio = 1 + ratio;
      }
      this.zoomTo(imageData.width * ratio / imageData.naturalWidth, showTooltip, pivot, _originalEvent);
      return this;
    },
    /**
     * Zoom the image to an absolute ratio.
     * @param {number} ratio - The target ratio.
     * @param {boolean} [showTooltip] - Indicates whether to show the tooltip.
     * @param {Object} [pivot] - The pivot point coordinate for zooming.
     * @param {Event} [_originalEvent=null] - The original event if any.
     * @param {Event} [_zoomable=false] - Indicates if the current zoom is available or not.
     * @returns {Viewer} this
     */
    zoomTo: function zoomTo(ratio) {
      var _this6 = this;
      var showTooltip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var pivot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var _originalEvent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var _zoomable = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var element = this.element,
        options = this.options,
        pointers = this.pointers,
        imageData = this.imageData;
      var x = imageData.x,
        y = imageData.y,
        width = imageData.width,
        height = imageData.height,
        naturalWidth = imageData.naturalWidth,
        naturalHeight = imageData.naturalHeight;
      ratio = Math.max(0, ratio);
      if (isNumber(ratio) && this.viewed && !this.played && (_zoomable || options.zoomable)) {
        if (!_zoomable) {
          var minZoomRatio = Math.max(0.01, isFunction(options.minZoomRatio) ? options.minZoomRatio.call(this, this.image, imageData) : options.minZoomRatio);
          var maxZoomRatio = Math.min(100, isFunction(options.maxZoomRatio) ? options.maxZoomRatio.call(this, this.image, imageData) : options.maxZoomRatio);
          ratio = Math.min(Math.max(ratio, minZoomRatio), maxZoomRatio);
        }
        if (_originalEvent) {
          switch (_originalEvent.type) {
            case 'wheel':
              if (options.zoomRatio >= 0.055 && ratio > 0.95 && ratio < 1.05) {
                ratio = 1;
              }
              break;
            case 'pointermove':
            case 'touchmove':
            case 'mousemove':
              if (ratio > 0.99 && ratio < 1.01) {
                ratio = 1;
              }
              break;
          }
        }
        var newWidth = naturalWidth * ratio;
        var newHeight = naturalHeight * ratio;
        var offsetWidth = newWidth - width;
        var offsetHeight = newHeight - height;
        var oldRatio = imageData.ratio;
        if (isFunction(options.zoom)) {
          addListener(element, EVENT_ZOOM, options.zoom, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_ZOOM, {
          ratio: ratio,
          oldRatio: oldRatio,
          originalEvent: _originalEvent
        }) === false) {
          return this;
        }
        this.zooming = true;
        if (_originalEvent) {
          var offset = getOffset(this.viewer);
          var center = pointers && Object.keys(pointers).length > 0 ? getPointersCenter(pointers) : {
            pageX: _originalEvent.pageX,
            pageY: _originalEvent.pageY
          };

          // Zoom from the triggering point of the event
          imageData.x -= offsetWidth * ((center.pageX - offset.left - x) / width);
          imageData.y -= offsetHeight * ((center.pageY - offset.top - y) / height);
        } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
          imageData.x -= offsetWidth * ((pivot.x - x) / width);
          imageData.y -= offsetHeight * ((pivot.y - y) / height);
        } else {
          // Zoom from the center of the image
          imageData.x -= offsetWidth / 2;
          imageData.y -= offsetHeight / 2;
        }
        imageData.left = imageData.x;
        imageData.top = imageData.y;
        imageData.width = newWidth;
        imageData.height = newHeight;
        imageData.oldRatio = oldRatio;
        imageData.ratio = ratio;
        toggleClass(this.image, CLASS_TRANSITION, isTransitionEnabled(options, 'zoom'));
        this.renderImage(function () {
          _this6.zooming = false;
          if (isFunction(options.zoomed)) {
            addListener(element, EVENT_ZOOMED, options.zoomed, {
              once: true
            });
          }
          dispatchEvent(element, EVENT_ZOOMED, {
            ratio: ratio,
            oldRatio: oldRatio,
            originalEvent: _originalEvent
          }, {
            cancelable: false
          });
        });
        if (showTooltip) {
          this.tooltip();
        }
      }
      return this;
    },
    /**
     * Play the images
     * @param {boolean|FullscreenOptions} [fullscreen=false] - Indicate if request fullscreen or not.
     * @returns {Viewer} this
     */
    play: function play() {
      var _this7 = this;
      var fullscreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.isShown || this.played) {
        return this;
      }
      var element = this.element,
        options = this.options;
      if (isFunction(options.play)) {
        addListener(element, EVENT_PLAY, options.play, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_PLAY) === false) {
        return this;
      }
      var player = this.player;
      var onLoad = this.loadImage.bind(this);
      var list = [];
      var total = 0;
      var index = 0;
      this.played = true;
      this.onLoadWhenPlay = onLoad;
      if (fullscreen) {
        this.requestFullscreen(fullscreen);
      }
      addClass(player, CLASS_SHOW);
      forEach(this.images, function (originalImage, i) {
        var image = document.createElement('img');
        image.src = _this7.getImageURL(originalImage) || originalImage.src;
        image.alt = originalImage.alt || '';
        image.referrerPolicy = originalImage.referrerPolicy;
        total += 1;
        addClass(image, CLASS_FADE);
        toggleClass(image, CLASS_TRANSITION, isTransitionEnabled(options, 'play'));
        if (i === _this7.index) {
          addClass(image, CLASS_IN);
          index = i;
        }
        list.push(image);
        addListener(image, EVENT_LOAD, onLoad, {
          once: true
        });
        player.appendChild(image);
      });
      if (isNumber(options.interval) && options.interval > 0) {
        var _prev = function prev() {
          clearTimeout(_this7.playing.timeout);
          removeClass(list[index], CLASS_IN);
          index -= 1;
          index = index >= 0 ? index : total - 1;
          addClass(list[index], CLASS_IN);
          _this7.playing.timeout = options.autoplay ? setTimeout(_prev, options.interval) : null;
        };
        var _next = function next() {
          clearTimeout(_this7.playing.timeout);
          removeClass(list[index], CLASS_IN);
          index += 1;
          index = index < total ? index : 0;
          addClass(list[index], CLASS_IN);
          _this7.playing.timeout = options.autoplay ? setTimeout(_next, options.interval) : null;
        };
        if (total > 1) {
          this.playing = {
            prev: _prev,
            next: _next,
            timeout: options.autoplay ? setTimeout(_next, options.interval) : null
          };
        }
      }
      return this;
    },
    // Stop play
    stop: function stop() {
      var _this8 = this;
      if (!this.played) {
        return this;
      }
      var element = this.element,
        options = this.options;
      if (isFunction(options.stop)) {
        addListener(element, EVENT_STOP, options.stop, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_STOP) === false) {
        return this;
      }
      var player = this.player;
      clearTimeout(this.playing.timeout);
      this.playing = false;
      this.played = false;
      forEach(player.getElementsByTagName('img'), function (image) {
        removeListener(image, EVENT_LOAD, _this8.onLoadWhenPlay);
      });
      removeClass(player, CLASS_SHOW);
      player.innerHTML = '';
      this.exitFullscreen();
      return this;
    },
    // Enter modal mode (only available in inline mode)
    full: function full() {
      var _this9 = this;
      var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;
      if (!this.isShown || this.played || this.fulled || !options.inline) {
        return this;
      }
      this.fulled = true;
      this.open();
      addClass(this.button, CLASS_FULLSCREEN_EXIT);
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
      addClass(viewer, CLASS_FIXED);
      viewer.setAttribute('role', 'dialog');
      viewer.setAttribute('aria-labelledby', this.title.id);
      viewer.setAttribute('aria-modal', true);
      viewer.removeAttribute('style');
      setStyle(viewer, {
        zIndex: options.zIndex
      });
      if (options.focus) {
        this.enforceFocus();
      }
      this.initContainer();
      this.viewerData = assign({}, this.containerData);
      this.renderList();
      if (this.viewed) {
        this.initImage(function () {
          _this9.renderImage();
        });
      }
      return this;
    },
    // Exit modal mode (only available in inline mode)
    exit: function exit() {
      var _this0 = this;
      var options = this.options,
        viewer = this.viewer,
        image = this.image,
        list = this.list;
      if (!this.isShown || this.played || !this.fulled || !options.inline) {
        return this;
      }
      this.fulled = false;
      this.close();
      removeClass(this.button, CLASS_FULLSCREEN_EXIT);
      removeClass(list, CLASS_TRANSITION);
      if (this.viewed) {
        removeClass(image, CLASS_TRANSITION);
      }
      if (options.focus) {
        this.clearEnforceFocus();
      }
      viewer.removeAttribute('role');
      viewer.removeAttribute('aria-labelledby');
      viewer.removeAttribute('aria-modal');
      removeClass(viewer, CLASS_FIXED);
      setStyle(viewer, {
        zIndex: options.zIndexInline
      });
      this.viewerData = assign({}, this.parentData);
      this.renderViewer();
      this.renderList();
      if (this.viewed) {
        this.initImage(function () {
          _this0.renderImage();
        });
      }
      return this;
    },
    // Show the current ratio of the image with percentage
    tooltip: function tooltip() {
      var _this1 = this;
      var options = this.options,
        tooltipBox = this.tooltipBox,
        imageData = this.imageData;
      if (!this.viewed || this.played || !options.tooltip) {
        return this;
      }
      tooltipBox.textContent = "".concat(Math.round(imageData.ratio * 100), "%");
      if (!this.tooltipping) {
        if (isTransitionEnabled(options, 'tooltip')) {
          if (this.fading) {
            dispatchEvent(tooltipBox, EVENT_TRANSITION_END);
          }
          addClass(tooltipBox, CLASS_SHOW);
          addClass(tooltipBox, CLASS_FADE);
          addClass(tooltipBox, CLASS_TRANSITION);
          tooltipBox.removeAttribute('aria-hidden');

          // Force reflow to enable CSS3 transition
          tooltipBox.initialOffsetWidth = tooltipBox.offsetWidth;
          addClass(tooltipBox, CLASS_IN);
        } else {
          addClass(tooltipBox, CLASS_SHOW);
          tooltipBox.removeAttribute('aria-hidden');
        }
      } else {
        clearTimeout(this.tooltipping);
      }
      this.tooltipping = setTimeout(function () {
        if (isTransitionEnabled(options, 'tooltip')) {
          addListener(tooltipBox, EVENT_TRANSITION_END, function () {
            removeClass(tooltipBox, CLASS_SHOW);
            removeClass(tooltipBox, CLASS_FADE);
            removeClass(tooltipBox, CLASS_TRANSITION);
            tooltipBox.setAttribute('aria-hidden', true);
            _this1.fading = false;
          }, {
            once: true
          });
          removeClass(tooltipBox, CLASS_IN);
          _this1.fading = true;
        } else {
          removeClass(tooltipBox, CLASS_SHOW);
          tooltipBox.setAttribute('aria-hidden', true);
        }
        _this1.tooltipping = false;
      }, 1000);
      return this;
    },
    /**
     * Toggle the image size between its current size and natural size
     * @param {Event} [_originalEvent=null] - The original event if any.
     * @returns {Viewer} this
     */
    toggle: function toggle() {
      var _originalEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (this.imageData.ratio === 1) {
        this.zoomTo(this.imageData.oldRatio, true, null, _originalEvent);
      } else {
        this.zoomTo(1, true, null, _originalEvent);
      }
      return this;
    },
    // Reset the image to its initial state
    reset: function reset() {
      if (this.viewed && !this.played) {
        this.imageData = assign({}, this.initialImageData);
        this.renderImage();
      }
      return this;
    },
    /**
     * Update the viewer when images or options changed.
     * @param {Object} [updateOptions] - The options to update.
     * @returns {Viewer} this
     */
    update: function update(updateOptions) {
      var _this10 = this;
      var element = this.element,
        options = this.options,
        isImg = this.isImg;
      if (isPlainObject(updateOptions)) {
        assign(options, updateOptions);
      }

      // Destroy viewer if the target image was deleted
      if (isImg && !element.parentNode) {
        return this.destroy();
      }
      var images = [];
      forEach(isImg ? [element] : element.querySelectorAll('img'), function (image) {
        if (isFunction(options.filter)) {
          if (options.filter.call(_this10, image)) {
            images.push(image);
          }
        } else if (_this10.getImageURL(image)) {
          images.push(image);
        }
      });
      if (!images.length) {
        return this;
      }
      this.images = images;
      this.length = images.length;
      if (this.ready) {
        var changedIndexes = [];
        forEach(this.items, function (item) {
          var img = item.querySelector('img');
          var index = Number(getData(item, 'index'));
          var image = images[index];
          if (image && img) {
            if (image.src !== img.src

            // Title changed (#408)
            || image.alt !== img.alt) {
              changedIndexes.push(index);
            }
          } else {
            changedIndexes.push(index);
          }
        });
        setStyle(this.list, {
          width: 'auto'
        });
        this.initList();
        if (this.isShown) {
          if (this.length) {
            if (this.viewed) {
              var changedIndex = changedIndexes.indexOf(this.index);
              if (changedIndex >= 0) {
                this.viewed = false;
                this.view(Math.max(Math.min(this.index - changedIndex, this.length - 1), 0));
              } else {
                var activeItem = this.getItem(this.index);

                // Reactivate the current viewing item after reset the list.
                addClass(activeItem, CLASS_ACTIVE);
                activeItem.setAttribute('aria-selected', true);
              }
            }
          } else {
            this.image = null;
            this.viewed = false;
            this.index = 0;
            this.imageData = {};
            this.canvas.innerHTML = '';
            this.title.innerHTML = '';
          }
        }
      } else {
        this.build();
      }
      return this;
    },
    // Destroy the viewer
    destroy: function destroy() {
      var element = this.element,
        options = this.options;
      if (!element[NAMESPACE]) {
        return this;
      }
      this.destroyed = true;
      if (this.ready) {
        if (this.played) {
          this.stop();
        }
        if (options.inline) {
          if (this.fulled) {
            this.exit();
          }
          this.unbind();
        } else if (this.isShown) {
          if (this.viewing) {
            if (this.imageRendering) {
              this.imageRendering.abort();
            } else if (this.imageInitializing) {
              this.imageInitializing.abort();
            }
          }
          if (this.hiding) {
            this.transitioning.abort();
          }
          this.hidden();
        } else if (this.showing) {
          this.transitioning.abort();
          this.hidden();
        }
        this.ready = false;
        this.viewer.parentNode.removeChild(this.viewer);
      } else if (options.inline) {
        if (this.delaying) {
          this.delaying.abort();
        } else if (this.initializing) {
          this.initializing.abort();
        }
      }
      if (!options.inline) {
        removeListener(element, EVENT_CLICK, this.onElementClick);
        removeListener(element, EVENT_KEY_DOWN, this.onElementKeyDown);
      }
      element[NAMESPACE] = undefined;
      return this;
    }
  };

  var others = {
    getImageURL: function getImageURL(image) {
      var url = this.options.url;
      if (isString(url)) {
        url = image.getAttribute(url);
      } else if (isFunction(url)) {
        url = url.call(this, image);
      } else {
        url = '';
      }
      return url;
    },
    enforceFocus: function enforceFocus() {
      var _this = this;
      this.clearEnforceFocus();
      addListener(document, EVENT_FOCUSIN, this.onFocusin = function (event) {
        var viewer = _this.viewer;
        var target = event.target;
        if (target === document || target === viewer || viewer.contains(target)) {
          return;
        }
        while (target) {
          // Avoid conflicts with other modals (#474, #540)
          if (target.getAttribute('tabindex') !== null || target.getAttribute('aria-modal') === 'true') {
            return;
          }
          target = target.parentElement;
        }
        viewer.focus();
      });
    },
    clearEnforceFocus: function clearEnforceFocus() {
      if (this.onFocusin) {
        removeListener(document, EVENT_FOCUSIN, this.onFocusin);
        this.onFocusin = null;
      }
    },
    open: function open() {
      var body = this.body;
      addClass(body, CLASS_OPEN);
      if (this.scrollbarWidth > 0) {
        body.style.paddingRight = "".concat(this.scrollbarWidth + (parseFloat(this.initialBodyComputedPaddingRight) || 0), "px");
      }
    },
    close: function close() {
      var body = this.body;
      removeClass(body, CLASS_OPEN);
      if (this.scrollbarWidth > 0) {
        body.style.paddingRight = this.initialBodyPaddingRight;
      }
    },
    shown: function shown() {
      var element = this.element,
        options = this.options,
        viewer = this.viewer;
      this.fulled = true;
      this.isShown = true;
      this.render();
      this.bind();
      this.showing = false;
      if (options.focus) {
        viewer.focus();
        this.enforceFocus();
      }
      if (isFunction(options.shown)) {
        addListener(element, EVENT_SHOWN, options.shown, {
          once: true
        });
      }
      if (dispatchEvent(element, EVENT_SHOWN) === false) {
        return;
      }
      if (this.ready && this.isShown && !this.hiding) {
        this.view(this.index);
      }
    },
    hidden: function hidden() {
      var element = this.element,
        options = this.options,
        viewer = this.viewer;
      var activeElement = viewer.ownerDocument.activeElement;

      // Avoid keeping focus inside the dialog before setting `aria-hidden`.
      if (activeElement && viewer.contains(activeElement) && isFunction(activeElement.blur)) {
        activeElement.blur();
      }
      if (options.focus) {
        this.clearEnforceFocus();
      }
      this.close();
      this.unbind();
      addClass(viewer, CLASS_HIDE);
      viewer.removeAttribute('role');
      viewer.removeAttribute('aria-labelledby');
      viewer.removeAttribute('aria-modal');
      viewer.setAttribute('aria-hidden', true);
      this.resetList();
      this.resetImage();
      this.fulled = false;
      this.viewed = false;
      this.isShown = false;
      this.hiding = false;
      if (!this.destroyed) {
        if (isFunction(options.hidden)) {
          addListener(element, EVENT_HIDDEN, options.hidden, {
            once: true
          });
        }
        dispatchEvent(element, EVENT_HIDDEN, null, {
          cancelable: false
        });
      }
    },
    requestFullscreen: function requestFullscreen(options) {
      var document = this.ownerDocument;
      if (this.fulled && !(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        var documentElement = document.documentElement;

        // Element.requestFullscreen()
        if (documentElement.requestFullscreen) {
          // Avoid TypeError when convert `options` to dictionary
          if (isPlainObject(options)) {
            documentElement.requestFullscreen(options);
          } else {
            documentElement.requestFullscreen();
          }
        } else if (documentElement.webkitRequestFullscreen) {
          documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (documentElement.mozRequestFullScreen) {
          documentElement.mozRequestFullScreen();
        } else if (documentElement.msRequestFullscreen) {
          documentElement.msRequestFullscreen();
        }
      }
    },
    exitFullscreen: function exitFullscreen() {
      var document = this.ownerDocument;
      if (this.fulled && (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement)) {
        // Document.exitFullscreen()
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    },
    change: function change(event) {
      var options = this.options,
        pointers = this.pointers;
      var pointer = pointers[Object.keys(pointers)[0]];

      // In the case of the `pointers` object is empty (#421)
      if (!pointer) {
        return;
      }
      var offsetX = pointer.endX - pointer.startX;
      var offsetY = pointer.endY - pointer.startY;
      switch (this.action) {
        // Move the current image
        case ACTION_MOVE:
          if (offsetX !== 0 || offsetY !== 0) {
            this.pointerMoved = true;
            this.move(offsetX, offsetY, event);
          }
          break;

        // Zoom the current image
        case ACTION_ZOOM:
          if (options.zoomable && options.zoomOnTouch) {
            var zoomRatio = getMaxZoomRatio(pointers);
            if (zoomRatio !== 0) {
              this.zoom(zoomRatio, false, null, event);
            }
          }
          break;

        // Rotate the current image
        case ACTION_ROTATE:
          if (options.rotatable && options.rotateOnTouch) {
            var rotateDegree = getMaxRotateDegree(pointers);
            if (rotateDegree !== 0) {
              this.rotate(rotateDegree, event);
            }
          }
          break;

        // Transform the current image
        case ACTION_TRANSFORM:
          if (options.zoomable && options.zoomOnTouch) {
            var _zoomRatio = getMaxZoomRatio(pointers);
            if (_zoomRatio !== 0) {
              this.zoom(_zoomRatio, false, null, event);
            }
          }
          if (options.rotatable && options.rotateOnTouch) {
            var _rotateDegree = getMaxRotateDegree(pointers);
            if (_rotateDegree !== 0) {
              this.rotate(_rotateDegree, event);
            }
          }
          break;
        case ACTION_SWITCH:
          {
            this.action = 'switched';
            var absoluteOffsetX = Math.abs(offsetX);
            if (absoluteOffsetX > 1 && absoluteOffsetX > Math.abs(offsetY)) {
              // Empty `pointers` as `touchend` event will not be fired after swiped in iOS browsers.
              this.pointers = {};
              if (offsetX > 1) {
                this.prev(options.loop);
              } else if (offsetX < -1) {
                this.next(options.loop);
              }
            }
            break;
          }
      }

      // Override
      forEach(pointers, function (p) {
        p.startX = p.endX;
        p.startY = p.endY;
      });
    },
    isSwitchable: function isSwitchable() {
      var imageData = this.imageData,
        viewerData = this.viewerData;
      return this.length > 1 && imageData.x >= 0 && imageData.y >= 0 && imageData.width <= viewerData.width && imageData.height <= viewerData.height;
    }
  };

  var AnotherViewer = WINDOW.Viewer;
  var getUniqueID = function (id) {
    return function () {
      id += 1;
      return id;
    };
  }(-1);
  var Viewer = /*#__PURE__*/function () {
    /**
     * Create a new Viewer.
     * @param {Element} element - The target image, or a container of images, to view.
     * @param {Object} [options={}] - The configuration options.
     */
    function Viewer(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Viewer);
      if (!element || element.nodeType !== 1 && element.nodeType !== 11) {
        throw new Error('The first argument is required and must be an element.');
      }
      this.element = element;
      this.ownerDocument = element.ownerDocument || element.host.ownerDocument;
      this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
      this.action = false;
      this.fading = false;
      this.fulled = false;
      this.hiding = false;
      this.imageClicked = false;
      this.imageData = {};
      this.index = this.options.initialViewIndex;
      this.isImg = false;
      this.isShown = false;
      this.length = 0;
      this.moving = false;
      this.played = false;
      this.playing = false;
      this.pointers = {};
      this.ready = false;
      this.rotating = false;
      this.scaling = false;
      this.showing = false;
      this.timeout = false;
      this.tooltipping = false;
      this.viewed = false;
      this.viewing = false;
      this.wheeling = false;
      this.zooming = false;
      this.pointerMoved = false;
      this.id = getUniqueID();
      this.init();
    }
    return _createClass(Viewer, [{
      key: "init",
      value: function init() {
        var _this = this;
        var element = this.element,
          options = this.options;
        if (element[NAMESPACE]) {
          return;
        }
        element[NAMESPACE] = this;

        // The `focus` option requires the `keyboard` option set to `true`.
        if (options.focus && !options.keyboard) {
          options.focus = false;
        }
        var isImg = element.localName === 'img';
        var images = [];
        forEach(isImg ? [element] : element.querySelectorAll('img'), function (image) {
          if (isFunction(options.filter)) {
            if (options.filter.call(_this, image)) {
              images.push(image);
            }
          } else if (_this.getImageURL(image)) {
            images.push(image);
          }
        });
        this.isImg = isImg;
        this.length = images.length;
        this.images = images;
        this.initBody();

        // Override `transition` option if it is not supported
        if (isUndefined(this.ownerDocument.createElement(NAMESPACE).style.transition)) {
          options.transition = false;
        }
        if (options.inline) {
          var count = 0;
          var progress = function progress() {
            count += 1;
            if (count === _this.length) {
              var timeout;
              _this.initializing = false;
              _this.delaying = {
                abort: function abort() {
                  clearTimeout(timeout);
                }
              };

              // build asynchronously to keep `this.viewer` is accessible in `ready` event handler.
              timeout = setTimeout(function () {
                _this.delaying = false;
                _this.build();
              }, 0);
            }
          };
          this.initializing = {
            abort: function abort() {
              forEach(images, function (image) {
                if (!image.complete) {
                  removeListener(image, EVENT_LOAD, progress);
                  removeListener(image, EVENT_ERROR, progress);
                }
              });
            }
          };
          forEach(images, function (image) {
            if (image.complete) {
              progress();
            } else {
              var onLoad;
              var onError;
              addListener(image, EVENT_LOAD, onLoad = function onLoad() {
                removeListener(image, EVENT_ERROR, onError);
                progress();
              }, {
                once: true
              });
              addListener(image, EVENT_ERROR, onError = function onError() {
                removeListener(image, EVENT_LOAD, onLoad);
                progress();
              }, {
                once: true
              });
            }
          });
        } else {
          addListener(element, EVENT_CLICK, this.onElementClick = function (_ref) {
            var target = _ref.target;
            if (target.localName === 'img' && (!isFunction(options.filter) || options.filter.call(_this, target))) {
              _this.view(_this.images.indexOf(target));
            }
          });
          addListener(element, EVENT_KEY_DOWN, this.onElementKeyDown = function (event) {
            var target = event.target,
              key = event.key;
            if (target.localName === 'img' && (key === 'Enter' || key === ' ')) {
              event.preventDefault();
              if (!isFunction(options.filter) || options.filter.call(_this, target)) {
                _this.view(_this.images.indexOf(target));
              }
            }
          });
        }
      }
    }, {
      key: "build",
      value: function build() {
        if (this.ready) {
          return;
        }
        var element = this.element,
          options = this.options;
        var parent = element.parentNode;
        var template = document.createElement('div');
        template.innerHTML = TEMPLATE;
        var viewer = template.querySelector(".".concat(NAMESPACE, "-container"));
        var title = viewer.querySelector(".".concat(NAMESPACE, "-title"));
        var toolbar = viewer.querySelector(".".concat(NAMESPACE, "-toolbar"));
        var navbar = viewer.querySelector(".".concat(NAMESPACE, "-navbar"));
        var navigation = viewer.querySelector(".".concat(NAMESPACE, "-navigation"));
        var button = viewer.querySelector(".".concat(NAMESPACE, "-button"));
        var canvas = viewer.querySelector(".".concat(NAMESPACE, "-canvas"));
        this.parent = parent;
        this.viewer = viewer;
        this.title = title;
        this.toolbar = toolbar;
        this.navbar = navbar;
        this.navigation = navigation;
        this.button = button;
        this.canvas = canvas;
        this.footer = viewer.querySelector(".".concat(NAMESPACE, "-footer"));
        this.magnifier = viewer.querySelector(".".concat(NAMESPACE, "-magnifier"));
        this.magnifierImage = viewer.querySelector(".".concat(NAMESPACE, "-magnifier-image"));
        this.tooltipBox = viewer.querySelector(".".concat(NAMESPACE, "-tooltip"));
        this.player = viewer.querySelector(".".concat(NAMESPACE, "-player"));
        this.list = viewer.querySelector(".".concat(NAMESPACE, "-list"));
        viewer.id = "".concat(NAMESPACE).concat(this.id);
        title.id = "".concat(NAMESPACE, "Title").concat(this.id);
        addClass(title, !options.title ? CLASS_HIDE : getResponsiveClass(Array.isArray(options.title) ? options.title[0] : options.title));
        var navbarOptions = isPlainObject(options.navbar) ? options.navbar : {};
        var navbarShow = options.navbar;
        var navbarSize = !isUndefined(navbarOptions.size) ? navbarOptions.size : options.navbar;
        if (isPlainObject(options.navbar)) {
          navbarShow = !isUndefined(navbarOptions.show) ? navbarOptions.show : true;
        }
        addClass(navbar, !navbarShow ? CLASS_HIDE : getResponsiveClass(navbarShow));
        if (['small', 'medium', 'large'].indexOf(navbarSize) !== -1) {
          addClass(navbar, "".concat(NAMESPACE, "-").concat(navbarSize));
        }
        if (isPlainObject(options.navigation)) {
          forEach(navigation.querySelectorAll('[role="button"]'), function (item) {
            var name = getData(item, DATA_ACTION);
            var value = options.navigation[name];
            var deep = isPlainObject(value);
            var show = deep && !isUndefined(value.show) ? value.show : value;
            var size = deep && !isUndefined(value.size) ? value.size : value;
            toggleClass(item, CLASS_HIDE, !show);
            if (isNumber(show)) {
              addClass(item, getResponsiveClass(show));
            }
            if (['small', 'large'].indexOf(size) !== -1) {
              addClass(item, "".concat(NAMESPACE, "-").concat(size));
            }
          });
        } else {
          addClass(navigation, !options.navigation ? CLASS_HIDE : getResponsiveClass(options.navigation));
        }
        toggleClass(button, CLASS_HIDE, !options.button);
        if (options.keyboard) {
          button.setAttribute('tabindex', 0);
          forEach(navigation.querySelectorAll('[role="button"]'), function (item) {
            item.setAttribute('tabindex', 0);
          });
        }
        if (options.backdrop) {
          addClass(viewer, "".concat(NAMESPACE, "-backdrop"));
          if (!options.inline && options.backdrop !== 'static') {
            setData(canvas, DATA_ACTION, 'hide');
          }
        }
        if (isString(options.className) && options.className) {
          // In case there are multiple class names
          options.className.split(REGEXP_SPACES).forEach(function (className) {
            addClass(viewer, className);
          });
        }
        if (options.toolbar) {
          var list = document.createElement('ul');
          var custom = isPlainObject(options.toolbar);
          var zoomButtons = BUTTONS.slice(0, 3);
          var rotateButtons = BUTTONS.slice(7, 9);
          var scaleButtons = BUTTONS.slice(9);
          if (!custom) {
            addClass(toolbar, getResponsiveClass(options.toolbar));
          }
          forEach(custom ? options.toolbar : BUTTONS, function (value, index) {
            var deep = custom && isPlainObject(value);
            var name = custom ? hyphenate(index) : value;
            var show = deep && !isUndefined(value.show) ? value.show : value;
            if (!show || !options.zoomable && zoomButtons.indexOf(name) !== -1 || !options.rotatable && rotateButtons.indexOf(name) !== -1 || !options.scalable && scaleButtons.indexOf(name) !== -1) {
              return;
            }
            var size = deep && !isUndefined(value.size) ? value.size : value;
            var click = deep && !isUndefined(value.click) ? value.click : value;
            var item = document.createElement('li');
            if (options.keyboard) {
              item.setAttribute('tabindex', 0);
            }
            item.setAttribute('role', 'button');
            addClass(item, "".concat(NAMESPACE, "-").concat(name));
            if (!isFunction(click)) {
              setData(item, DATA_ACTION, name);
            }
            if (isNumber(show)) {
              addClass(item, getResponsiveClass(show));
            }
            if (['small', 'large'].indexOf(size) !== -1) {
              addClass(item, "".concat(NAMESPACE, "-").concat(size));
            } else if (name === 'play') {
              addClass(item, "".concat(NAMESPACE, "-large"));
            }
            if (isFunction(click)) {
              addListener(item, EVENT_CLICK, click);
            }
            list.appendChild(item);
          });
          toolbar.appendChild(list);
        } else {
          addClass(toolbar, CLASS_HIDE);
        }
        if (!options.rotatable) {
          var rotates = toolbar.querySelectorAll('li[class*="rotate"]');
          addClass(rotates, CLASS_INVISIBLE);
          forEach(rotates, function (rotate) {
            toolbar.appendChild(rotate);
          });
        }
        if (options.inline) {
          addClass(button, CLASS_FULLSCREEN);
          setStyle(viewer, {
            zIndex: options.zIndexInline
          });
          if (window.getComputedStyle(parent).position === 'static') {
            setStyle(parent, {
              position: 'relative'
            });
          }
          parent.insertBefore(viewer, element.nextSibling);
        } else {
          addClass(button, CLASS_CLOSE);
          addClass(viewer, CLASS_FIXED);
          addClass(viewer, CLASS_FADE);
          addClass(viewer, CLASS_HIDE);
          setStyle(viewer, {
            zIndex: options.zIndex
          });
          var container = options.container;
          if (isString(container)) {
            container = this.ownerDocument.querySelector(container);
          }
          if (!container) {
            container = this.body;
          }
          container.appendChild(viewer);
        }
        if (options.inline) {
          this.render();
          this.bind();
          this.isShown = true;
        }
        this.ready = true;
        if (isFunction(options.ready)) {
          addListener(element, EVENT_READY, options.ready, {
            once: true
          });
        }
        if (dispatchEvent(element, EVENT_READY) === false) {
          this.ready = false;
          return;
        }
        if (this.ready && options.inline) {
          this.view(this.index);
        }
      }

      /**
       * Create a new Viewer instance.
       * @param {Element} element - The target image, or a container of images, to view.
       * @param {Object} [options={}] - The configuration options.
       * @returns {Viewer} A new Viewer instance.
       */
    }], [{
      key: "create",
      value: function create(element, options) {
        return new Viewer(element, options);
      }

      /**
       * Change the default options.
       * @param {Object} options - The new default options.
       */
    }, {
      key: "setDefaults",
      value: function setDefaults(options) {
        assign(DEFAULTS, isPlainObject(options) && options);
      }

      /**
       * Get the no conflict viewer class.
       * @returns {Viewer} The viewer class.
       */
    }, {
      key: "noConflict",
      value: function noConflict() {
        window.Viewer = AnotherViewer;
        return Viewer;
      }
    }]);
  }();
  assign(Viewer.prototype, render, events, handlers, methods, others);

  return Viewer;

}));


/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__utils_handy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_viewer__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(76);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_v_viewer___default.a);

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // common
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      handy: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a,
      config: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.rules,
      calFab: false,
      // create ticket
      lAction: '',
      tabItems: ['All Open', 'All Closed'],
      tab: 'tab-0',
      lSupport: {},
      departmentList: [],
      catList: [],
      subCatList: [],
      assignUserList: [],
      planStartDt: false,
      planEndDt: false,
      actStartDt: false,
      actEndDt: false,
      jobDoneDt: false,
      beingSaved: false,
      openTickets: [],
      closedTickets: [],
      ticketHead: [{ text: 'Ticket No', value: 'ticket_id', class: 'pa-2' }, { text: 'Created Date', value: 'created_dt', class: 'pa-2' }, { text: 'Department', value: 'dept_name', class: 'pa-2' }, { text: 'Category', value: 'cat', class: 'pa-2' }, { text: 'Description', value: 'description', class: 'pa-2 text-xs-center' }, { text: 'Created By', value: 'cust_name', class: 'pa-2' }, { text: 'Assigned to', value: 'assigned_to', class: 'pa-2' }, { text: 'Priority', value: 'priority', class: 'pa-2' }, { text: 'Status', value: 'status', class: 'pa-2' }, { text: 'Attach', sortable: false, value: 'attach' }, { text: '', sortable: false, value: 'action' }],
      choosenView: 'card',
      enabledFilter: [],
      filterListByTab: [],
      filterStatus: ['New', 'In Progress', 'Need More Info.', 'On-Hold', 'Cancelled', 'Job-Done', 'Completed', 'Reopen'],
      dlgFromDate: false,
      dlgToDate: false,
      showFilter: false,
      mcList: [],
      statusList: ['Need More Info.', 'On-Hold', 'Completed', 'Reopen', 'Cancelled'],
      lTicketStatus: [],
      placeHolder: '',
      showDlgStatus: false,
      lTimeLine: [],
      showTimeline: false,
      previousData: [],
      dlgEndDate: false,
      priorityList: [],
      options: {
        toolbar: true,
        url: 'data-source'
      },
      ticketLists: []
    };
  },
  created: function created() {
    for (var i = 0; i < this.tabItems.length; i++) {
      this.enabledFilter['tab-' + i] = false;
      this.filterListByTab['tab-' + i] = this.getEmptyFilter();
    }
  },

  computed: {
    today: function today() {
      return __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(Date());
    }
  },
  mounted: function mounted() {
    var curDate = new Date();
    this.lSupport.planned_start_dt = __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(curDate);
    this.loadTickets();
    this.lAction = 'view';
  },

  methods: {
    msg: function msg(m) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (type === 0) {
        this.sbarCol = 'error';
      } else if (type === 1) {
        this.sbarCol = 'success';
      } else {
        this.sbarCol = 'info';
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    getEmptyTickets: function getEmptyTickets() {
      var emptyTicket = {
        dep_pair: '',
        cat_pair: '',
        sub_cat_pair: '',
        description: '',
        planned_start_dt: this.lSupport.planned_start_dt,
        end_dt: null,
        priority_pair: {
          priority_id: 1,
          priority: 'Normal'
        },
        status: 'New',
        assigned_to_pair: {},
        others: '',
        comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
        created_by: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.USER_ID
      };
      return emptyTicket;
    },
    prepareCreate: function prepareCreate() {
      this.lSupport = this.getEmptyTickets();
      this.lAction = 'Create';
      this.loadDepartments();
      this.loadAssignUserList();
      this.loadPriorityList();
    },
    loadDepartments: function loadDepartments() {
      var _this = this;

      var qry = {
        params: {
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getDepartmentsList/', qry).then(function (response) {
        _this.departmentList = response.data;
      }).catch(function (err) {
        _this.msg(err.response.data, true);
        _this.departmentList = [];
      });
    },
    loadCategories: function loadCategories(curDept) {
      var _this2 = this;

      var qry = {
        params: {
          dept_id: curDept.dept_id,
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getCategoriesBasedOnDeptId/', qry).then(function (response) {
        _this2.catList = response.data;
      }).catch(function (err) {
        _this2.msg(err.response.data, true);
        _this2.catList = [];
      });
    },
    loadSubCatList: function loadSubCatList(curCat) {
      var _this3 = this;

      var qry = {
        params: {
          cat_id: curCat.cat_id
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getSubCatBasedOnCatId/', qry).then(function (response) {
        _this3.subCatList = response.data;
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
        _this3.subCatList = [];
      });
    },
    loadPriorityList: function loadPriorityList() {
      var _this4 = this;

      var qry = {
        params: {
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getPriorityList/', qry).then(function (response) {
        _this4.priorityList = response.data;
      }).catch(function (err) {
        _this4.msg(err);
        _this4.priorityList = [];
      });
    },
    loadAssignUserList: function loadAssignUserList() {
      var _this5 = this;

      var qry = {
        params: {
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getBackOfficeStaffs/', qry).then(function (response) {
        _this5.assignUserList = response.data;
      }).catch(function (err) {
        _this5.msg(err.response.data, true);
        _this5.assignUserList = [];
      });
    },
    cancelChanges: function cancelChanges() {
      this.lAction = 'view';
    },
    saveTicket: function saveTicket(action) {
      var _this6 = this;

      if (!this.$refs.sForm.validate()) {
        return;
      }
      if (!this.lSupport.planned_start_dt) {
        this.msg('Please select planned start date', 0);
      }
      if (action === 'Create' || action === 'Update') {
        this.lSupport.notes = '';
      }
      if (action === 'Update') {
        if (this.previousData.cat_pair.cat_id !== this.lSupport.cat_pair.cat_id) {
          this.lSupport.notes += ' Category changed to "' + this.lSupport.cat_pair.cat + '",';
        }
        if (this.previousData.sub_cat_pair.sub_cat_id !== this.lSupport.sub_cat_pair.sub_cat_id) {
          this.lSupport.notes += ' Sub category changed to "' + this.lSupport.sub_cat_pair.sub_cat + '",';
        }
        if (this.previousData.description !== this.lSupport.description) {
          this.lSupport.notes += ' Description from "' + this.previousData.description + '" to "' + this.lSupport.description + '",';
        }
        if (this.previousData.planned_start_dt !== this.lSupport.planned_start_dt) {
          this.lSupport.notes += ' Start date changed to "' + this.lSupport.planned_start_dt + '",';
        }
        if (this.previousData.planned_end_dt !== this.lSupport.planned_end_dt) {
          this.lSupport.notes += ' End date changed to "' + this.lSupport.planned_end_dt + '",';
        }
        if (this.previousData.status !== this.lSupport.status) {
          this.lSupport.notes += ' Status changed to "' + this.lSupport.status + '",';
        }
        if (this.previousData.priority !== this.lSupport.priority) {
          this.lSupport.notes += ' Priority changed to "' + this.lSupport.priority + '"';
        }
      }
      if (!this.lSupport.files) {
        this.lSupport.files = [];
      }
      this.lSupport.dept_id = this.lSupport.dep_pair.dept_id;
      this.lSupport.cat_id = this.lSupport.cat_pair.cat_id;
      this.lSupport.sub_cat_id = this.lSupport.sub_cat_pair.sub_cat_id ? this.lSupport.sub_cat_pair.sub_cat_id : null;
      this.lSupport.priority_id = this.lSupport.priority_pair.priority_id;
      this.lSupport.vendor_id = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID;
      this.lSupport.updated_by = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.USER_ID;
      this.lSupport.assigned_to = this.lSupport.assigned_to_pair.emp_id ? this.lSupport.assigned_to_pair.emp_id : null;
      this.lSupport.is_sv_user = false;
      this.lSupport.is_updated_by_sv_user = false;
      this.lSupport.is_action_by_sv_user = false;
      this.beignSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/backOfficeSupport/' + action, this.lSupport).then(function (response) {
        _this6.lAction = 'view';
        _this6.loadTickets();
        _this6.loadTicketAttachment(_this6.lSupport.ticket_id);
        _this6.beingSaved = false;
      }).catch(function (err) {
        _this6.msg(err.response.data);
        _this6.beingSaved = false;
      });
    },
    loadTickets: function loadTickets() {
      var _this7 = this;

      var qry = {
        params: {
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID,
          comm_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          filter: this.filterListByTab[this.tab]
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getTicketsList/', qry).then(function (response) {
        _this7.ticketLists = response.data;
        _this7.openTickets = response.data.filter(function (rec) {
          return rec.status !== 'Completed' && rec.status !== 'Cancelled';
        });
        _this7.closedTickets = response.data.filter(function (rec) {
          return rec.status === 'Completed' || rec.status === 'Cancelled';
        });
      }).catch(function (err) {
        _this7.msg(err);
        _this7.ticketLists = [];
      });
    },
    prepareUpdate: function prepareUpdate(curTicket) {
      this.lSupport = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, curTicket);
      this.lSupport.action_by = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.USER_ID;
      this.lSupport.dep_pair = { dept_id: this.lSupport.dept_id, dept_name: this.lSupport.dept_name };
      this.lSupport.cat_pair = { cat_id: this.lSupport.cat_id, cat: this.lSupport.cat };
      this.lSupport.sub_cat_pair = { sub_cat_id: this.lSupport.sub_cat_id, sub_cat: this.lSupport.sub_cat };
      this.lSupport.planned_start_dt = this.lSupport.planned_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lSupport.planned_start_dt) : null;
      this.lSupport.planned_end_dt = this.lSupport.planned_end_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lSupport.planned_end_dt) : null;
      this.lSupport.act_start_dt = this.lSupport.act_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(this.lSupport.act_start_dt) : null;
      this.lSupport.act_end_dt = this.lSupport.act_end_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(this.lSupport.act_end_dt) : null;
      this.lSupport.job_done_dt = this.lSupport.job_done_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDateTime(this.lSupport.job_done_dt) : null;
      this.lSupport.assigned_to_pair = { emp_id: curTicket.emp_id, emp_name_with_id: curTicket.emp_name_with_id };
      this.previousData = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.lSupport);
      this.lSupport.priority_pair = { priority_id: this.lSupport.priority_id, priority: this.lSupport.priority };
      this.lSupport.assign_comments = '';
      this.loadTicketAttachment(curTicket.ticket_id);
      this.lAction = 'Update';
      this.loadDepartments(curTicket);
      this.loadCategories(curTicket);
      this.loadSubCatList(curTicket);
      this.loadAssignUserList(curTicket);
      this.loadPriorityList();
    },
    deleteTicket: function deleteTicket(curTicket) {
      var _this8 = this;

      if (!confirm('Sure, you want to delete the ticket ?')) {
        return;
      }
      // up in db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/backOfficeSupport/delete', curTicket).then(function (response) {
        // refresh the list
        var idx = _this8.ticketLists.findIndex(function (ticket) {
          return ticket.ticket_id === curTicket.ticket_id;
        });
        _this8.ticketLists.splice(idx, 1);
        _this8.lAction = 'view';
        _this8.loadTickets();
        _this8.beingSaved = false;
      }).catch(function (err) {
        _this8.msg(err.response.data);
        _this8.beingSaved = false;
      });
    },
    changeView: function changeView(curView) {
      this.choosenView = curView;
    },
    prepareTicketStatus: function prepareTicketStatus(curTicket, curStatus) {
      this.lTicketStatus = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, curTicket);
      this.lTicketStatus.action = curStatus;
      this.lTicketStatus.notes = '';
      this.lTicketStatus.sub_action = 'create';
      if (curStatus === 'Comment') {
        this.placeHolder = 'Type your comment here...';
      } else if (curStatus === 'Need More Info.') {
        this.placeHolder = 'From whom you are looking for information..';
        this.lTicketStatus.act_start_dt = this.lTicketStatus.act_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lTicketStatus.act_start_dt) : null;
      } else if (curStatus === 'On-Hold') {
        this.placeHolder = 'Type your reason for On-hold...';
        this.lTicketStatus.act_start_dt = this.lTicketStatus.act_start_dt ? __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(this.lTicketStatus.act_start_dt) : null;
      } else if (curStatus === 'Completed') {
        this.lTicketStatus.planned_end_dt = this.today;
        this.placeHolder = 'Type your resolution here...';
        this.lTicketStatus.end_dt = this.today;
      }
      if (curStatus === 'On-Hold' || curStatus === 'Need More Info.' || curStatus === 'Completed' || curStatus === 'Cancelled' || curStatus === 'Reopen' || curStatus === 'Comment') {
        this.showDlgStatus = true;
      }
      this.$forceUpdate();
    },
    postTicketStatus: function postTicketStatus() {
      var _this9 = this;

      if (this.lTicketStatus.notes) {
        this.lTicketStatus.action_by = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.USER_ID;
        this.lTicketStatus.vendor_id = __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID;
        this.lTicketStatus.is_action_by_sv_user = false;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/backOfficeSupport/status', this.lTicketStatus).then(function (response) {
          _this9.loadTickets();
          _this9.showDlgStatus = false;
        }).catch(function (err) {
          _this9.msg(err, 0);
        });
      } else {
        this.msg('Please enter your comments', 0);
      }
    },
    loadTimeLine: function loadTimeLine(curTicket) {
      var _this10 = this;

      var qry = {
        params: {
          ticket_id: curTicket
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getTimelineDetailsByTicketId/', qry).then(function (response) {
        _this10.lTimeLine = response.data;
        var timeLineNote = [];
        timeLineNote = response.data.filter(function (rec) {
          return rec.action === 'Ticket Updated' && rec.notes !== null;
        });
        if (timeLineNote) {
          var note = '';
          var cidx = 0;
          for (var k = 0; k < timeLineNote.length; k++) {
            cidx = response.data.findIndex(function (rec) {
              return rec.ticket_det_id === timeLineNote[k].ticket_det_id;
            });
            note = timeLineNote[k].notes.split(',');
            _this10.lTimeLine[cidx].timeLineNote = [];
            for (var i = 0; i < note.length; i++) {
              _this10.lTimeLine[cidx].timeLineNote[i] = note[i];
            }
          }
        }
        _this10.loadTicketAttachment(curTicket);
        _this10.showTimeline = true;
        setTimeout(function () {
          var tmpItem = document.getElementById('timeline_' + (_this10.lTimeLine.length - 1));
          tmpItem.scrollIntoView();
        }, 100);
      }).catch(function (err) {
        _this10.msg(err, 0);
        _this10.lTimeLine = [];
        _this10.showTimeline = false;
      });
    },
    loadCreatedList: function loadCreatedList() {
      var _this11 = this;

      var qry = {
        params: {
          comm_id_list: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.COMM_ID,
          vendor_id: __WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.FM_VENDOR_ID
        }
      };
      this.mcList = [];
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getEligibleAssigneeForComplaints/', qry).then(function (response) {
        response.data.forEach(function (rec) {
          _this11.mcList.push({ user_id: rec.user_id, user_name: __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.startWithUpper(rec.cust_name), is_sv_user: rec.is_sv_user });
        });
      });
    },
    getEmptyFilter: function getEmptyFilter() {
      var filter = {
        from_dt: null,
        end_dt: null,
        created_user_pair_list: [],
        assigned_user_pair_list: [],
        ticket_cat_list: [],
        ticket_dept_list: [],
        priority_list: [],
        ticket_status_list: []
      };
      return filter;
    },
    prepareFilter: function prepareFilter() {
      this.showFilter = true;
      this.loadCreatedList();
      this.loadDepartments();
      this.loadAssignUserList();
      this.loadPriorityList();
    },
    applyFilter: function applyFilter() {
      if (this.filterListByTab[this.tab].from_dt > this.filterListByTab[this.tab].end_dt) {
        this.msg('to date should be greater than from date');
      } else {
        if (!this.filterListByTab[this.tab].from_dt && this.filterListByTab[this.tab].end_dt) {
          this.filterListByTab[this.tab].from_dt = this.filterListByTab[this.tab].end_dt;
        } else if (this.filterListByTab[this.tab].from_dt && !this.filterListByTab[this.tab].end_dt) {
          this.filterListByTab[this.tab].end_dt = this.filterListByTab[this.tab].from_dt;
        }
        if (this.filterListByTab[this.tab].assigned_user_pair_list.emp_id || this.filterListByTab[this.tab].created_user_pair_list.user_id || this.filterListByTab[this.tab].priority_list.length || this.filterListByTab[this.tab].ticket_cat_list.length || this.filterListByTab[this.tab].ticket_status_list.length || this.filterListByTab[this.tab].ticket_dept_list.dept_id || this.filterListByTab[this.tab].from_dt || this.filterListByTab[this.tab].end_dt) {
          this.enabledFilter[this.tab] = true;
        }
        this.loadTickets();
        this.showFilter = false;
        this.$forceUpdate();
      }
    },
    clearFilter: function clearFilter() {
      this.filterListByTab[this.tab].from_dt = null;
      this.filterListByTab[this.tab].end_dt = null;
      this.filterListByTab[this.tab].created_user_pair_list = [];
      this.filterListByTab[this.tab].assigned_user_pair_list = [];
      this.filterListByTab[this.tab].ticket_dept_list = [];
      this.filterListByTab[this.tab].ticket_cat_list = [];
      this.filterListByTab[this.tab].ticket_status_list = [];
      this.filterListByTab[this.tab].priority_list = [];
      this.enabledFilter[this.tab] = false;
      this.showFilter = false;
      this.loadTickets();
      this.$forceUpdate();
    },
    pickFile: function pickFile() {
      if (this.lAction === 'Update' || this.lAction === 'Create') {
        this.$refs.fileInput.click();
      } else {
        this.$refs.statusFileInput.click();
      }
    },
    loadFilesFromFileBrowser: function loadFilesFromFileBrowser(curTicket) {
      var _this12 = this;

      var files = event.target.files;
      if (!curTicket.files) {
        curTicket.files = [];
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(files).forEach(function (file) {
        var currentDate = new Date();
        var time = currentDate.getHours() + '-' + currentDate.getMinutes() + '-' + currentDate.getSeconds();
        var fileReader = new FileReader();
        var getResult = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          fileReader.onload = function (e) {
            curTicket.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + __WEBPACK_IMPORTED_MODULE_4__utils_handy___default.a.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            });
            _this12.$forceUpdate();
          };
        });
        fileReader.readAsDataURL(file);
        return getResult.then(function (file) {
          return file;
        });
      });
    },
    loadTicketAttachment: function loadTicketAttachment(curTicket, curTicketDet) {
      var _this13 = this;

      var path = __webpack_require__(368);
      var qry = {
        params: {
          ticket_id: curTicket
        }
      };
      this.lTimeLine.fileUrls = {};
      this.axios.get(__WEBPACK_IMPORTED_MODULE_3__config_app_cfg___default.a.API_URL + '/getAttachmentByTicketId/', qry).then(function (response) {
        _this13.lTimeLine.fileUrls = response.data;
        // make notes if they have done any change while updating the ticket
        var fileUrls = _this13.lTimeLine.fileUrls.filter(function (rec) {
          return rec.action === 'Ticket Created' || rec.action === 'Ticket Updated';
        });
        if (fileUrls.length > 0) {
          _this13.lSupport.files = [];
          fileUrls.forEach(function (rec) {
            _this13.lSupport.files.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            });
          });
        }
        _this13.lTimeLine.attachImages = [];
        _this13.lTimeLine.attachFile = [];
        _this13.lTimeLine.fileUrls.forEach(function (rec) {
          rec.extension = rec.file_url.split('.')[1];
          if (rec.extension.toLowerCase() === 'png' || rec.extension.toLowerCase() === 'jpg' || rec.extension.toLowerCase() === 'gif') {
            _this13.lTimeLine.attachImages.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            });
          } else {
            _this13.lTimeLine.attachFile.push({
              extension: rec.file_url.split('.')[1],
              file_url: rec.file_url,
              file_name: rec.file_url ? path.basename(rec.file_url) : '',
              is_selected: true,
              is_changed: false,
              action: rec.action,
              ticket_det_id: rec.ticket_det_id,
              ticket_id: rec.ticket_id
            });
          }
        });
        _this13.$forceUpdate();
      }).catch(function (err) {
        _this13.msg(err, true);
        _this13.lTimeLine.fileUrls = [];
      });
    },
    loadFilesFromBrowser: function loadFilesFromBrowser(curTicket) {
      var _this14 = this;

      var files = event.target.files;
      if (!curTicket.files) {
        curTicket.files = [];
      }
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(files).forEach(function (file) {
        var fileReader = new FileReader();
        var getResult = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
          fileReader.onload = function (e) {
            curTicket.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name,
              is_selected: true,
              is_changed: true
            });
            _this14.$forceUpdate();
          };
        });
        fileReader.readAsDataURL(file);
        return getResult.then(function (file) {
          return file;
        });
      });
    }
  }
});

/***/ }),

/***/ 858:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0 ma-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_c('v-badge', {
      attrs: {
        "overlap": ""
      },
      scopedSlots: _vm._u([(_vm.enabledFilter['tab-' + n]) ? {
        key: "badge",
        fn: function() {
          return [_c('v-icon', {
            staticClass: "caption"
          }, [_vm._v("filter_list")])]
        },
        proxy: true
      } : null], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "pa-2"
    }, [_vm._v(_vm._s(tabItem + ' (' + (tabItem === 'All Open' ? _vm.openTickets.length : _vm.closedTickets.length) + ')'))])])], 1)
  }), 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabItems), function(tabItem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [(_vm.choosenView === 'card') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm7": "",
        "mx-auto": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pt-3"
    }, [_c('v-data-iterator', {
      attrs: {
        "items": tabItem === 'All Open' ? _vm.openTickets : _vm.closedTickets,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "item",
        fn: function(props) {
          return [_c('v-layout', [_c('v-flex', {
            staticClass: "pb-2",
            attrs: {
              "xs12": ""
            }
          }, [_c('v-card', {
            staticClass: "grey lighten-4"
          }, [_c('v-card-text', {
            staticClass: "py-0"
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs10": "",
              "sm11": ""
            }
          }, [_c('div', {
            staticClass: "pt-3 subheading"
          }, [_c('b', [_vm._v(_vm._s('#' + props.item.ticket_id + ' - ' + props.item.dept_name + ' - ' + props.item.cat))])])]), _vm._v(" "), _c('v-flex', {
            staticClass: "pa-0",
            attrs: {
              "xs2": "",
              "sm1": ""
            }
          }, [_c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "bottom": "",
              "right": "",
              "close-on-content-click": false
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            staticClass: "ma-0",
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-group', {
            attrs: {
              "no-action": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function() {
                return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
              },
              proxy: true
            }], null, true),
            model: {
              value: (_vm.lSupport.status),
              callback: function($$v) {
                _vm.$set(_vm.lSupport, "status", $$v)
              },
              expression: "lSupport.status"
            }
          }, [_vm._v(" "), _vm._l((_vm.statusList), function(status, i) {
            return (((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')) ? _c('v-list-tile', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.prepareTicketStatus(props.item, status)
                }
              }
            }, [_c('v-list-tile-title', [_vm._v("\n                                    " + _vm._s(status) + "\n                                  ")])], 1) : _vm._e()
          })], 2), _vm._v(" "), (props.item.status !== 'Completed' && props.item.status !== 'Cancelled') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTicketStatus(props.item, 'Comment')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1), _vm._v(" "), (props.item.status === 'New' && props.item.assigned_to_name === null) ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.deleteTicket(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs12": ""
            }
          }, [_c('div', {
            staticClass: "pb-2"
          }, [_vm._v("\n                            " + _vm._s(props.item.description.substring(0, 150) + '...') + "\n                          ")]), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs12": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs6": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs3": "",
              "sm2": ""
            }
          }, [_c('v-avatar', {
            staticClass: "pt-0",
            attrs: {
              "slot": "activator",
              "size": "24px"
            },
            slot: "activator"
          }, [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.created_avatar_url
            }
          })])], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "caption",
            attrs: {
              "xs9": "",
              "sm10": ""
            }
          }, [_c('div', {
            staticClass: "primary--text"
          }, [_c('strong', [_vm._v("Created by")])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.item.created_by_name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.created_dt)))])])], 1)], 1), _vm._v(" "), _c('v-flex', {
            attrs: {
              "xs6": ""
            }
          }, [_c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            attrs: {
              "xs3": "",
              "sm2": ""
            }
          }, [_c('v-avatar', {
            staticClass: "pt-0",
            attrs: {
              "slot": "activator",
              "size": "24px"
            },
            slot: "activator"
          }, [(props.item.assigned_to) ? _c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + props.item.assigned_avatar_url
            }
          }) : _c('v-icon', {
            staticClass: "grey"
          }, [_vm._v("person")])], 1)], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "caption",
            attrs: {
              "xs9": "",
              "sm10": ""
            }
          }, [_c('div', {
            staticClass: "primary--text"
          }, [_c('strong', [_vm._v("Assigned to")])]), _vm._v(" "), (props.item.assigned_to) ? _c('div', [_c('div', [_vm._v(_vm._s(props.item.assigned_to_name))]), _vm._v(" "), (props.item.assigned_dt) ? _c('div', [_vm._v(_vm._s(_vm.handy.formatDate(props.item.assigned_dt) + ' ' + _vm.handy.getTime12Hrs(props.item.assigned_dt)))]) : _vm._e()]) : _c('div', [_vm._v("NA")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
            staticClass: "subheading",
            attrs: {
              "xs12": ""
            }
          }, [_c('v-divider', {
            staticClass: "pt-1"
          }), _vm._v(" "), _c('v-layout', {
            attrs: {
              "row": "",
              "wrap": ""
            }
          }, [_c('v-flex', {
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "xs5": ""
            }
          }, [_c('div', {
            staticClass: "pa-1",
            class: props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text'))
          }, [_c('span', {
            staticClass: "primary--text"
          }, [_vm._v(" Status: ")]), _vm._v(" "), _c('span', {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(" " + _vm._s(props.item.status) + " ")])])]), _vm._v(" "), _c('v-flex', {
            staticStyle: {
              "font-size": "14px"
            },
            attrs: {
              "xs5": ""
            }
          }, [_c('div', {
            staticClass: "pa-1"
          }, [_c('span', {
            staticClass: "primary--text"
          }, [_vm._v(" Priority: ")]), _vm._v(" "), _c('span', {
            staticClass: "green--text",
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(" " + _vm._s(props.item.priority) + " ")])])]), _vm._v(" "), (props.item.tot_files) ? _c('v-flex', {
            staticClass: "pa-1",
            attrs: {
              "xs2": ""
            },
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-badge', {
            attrs: {
              "overlap": "",
              "color": "info"
            },
            scopedSlots: _vm._u([{
              key: "badge",
              fn: function() {
                return [_c('span', {
                  staticClass: "caption"
                }, [_vm._v(_vm._s(props.item.tot_files))])]
              },
              proxy: true
            }], null, true)
          }, [_vm._v(" "), _c('v-icon', {
            staticClass: "pa-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("attach_file")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.choosenView === 'list') ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "mx-auto": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c('v-data-table', {
      staticClass: "elevation-1",
      attrs: {
        "headers": _vm.ticketHead,
        "items": tabItem === 'All Open' ? _vm.openTickets : _vm.closedTickets,
        "disable-initial-sort": "",
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('tr', [_c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.ticket_id))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(_vm.handy.formatDate(props.item.created_dt)))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.dept_name))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.cat))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.description.substring(0, 150) + '...'))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.created_by_name))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.assigned_to ? props.item.assigned_to_name : 'NA'))]), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_vm._v(_vm._s(props.item.priority))]), _vm._v(" "), _c('td', {
            class: 'pa-2 ' + (props.item.status === 'New' ? 'grey--text' : (props.item.status === 'In Progress' ? 'accent--text' : (props.item.status === 'Completed' ? 'success--text' : 'error--text')))
          }, [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [(props.item.tot_files) ? _c('v-badge', {
            attrs: {
              "overlap": "",
              "color": "info"
            },
            scopedSlots: _vm._u([{
              key: "badge",
              fn: function() {
                return [_c('span', {
                  staticClass: "caption"
                }, [_c('strong', [_vm._v(_vm._s(props.item.tot_files))])])]
              },
              proxy: true
            }], null, true)
          }, [_vm._v(" "), _c('v-icon', {
            staticClass: "pa-2",
            attrs: {
              "small": ""
            }
          }, [_vm._v("attach_file")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', {
            staticClass: "pa-2"
          }, [_c('v-menu', {
            staticClass: "mt-2",
            attrs: {
              "top": "",
              "right": "",
              "close-on-content-click": false
            }
          }, [_c('span', {
            attrs: {
              "slot": "activator"
            },
            slot: "activator"
          }, [_c('v-btn', {
            attrs: {
              "slot": "activator",
              "small": "",
              "icon": ""
            },
            slot: "activator"
          }, [_c('v-icon', [_vm._v("more_vert")])], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-group', {
            attrs: {
              "no-action": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function() {
                return [_c('v-list-tile', [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("track_changes")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Change Status")])], 1)]
              },
              proxy: true
            }], null, true),
            model: {
              value: (_vm.lSupport.status),
              callback: function($$v) {
                _vm.$set(_vm.lSupport, "status", $$v)
              },
              expression: "lSupport.status"
            }
          }, [_vm._v(" "), _vm._l((_vm.statusList), function(status, i) {
            return (((tabItem === 'All Open') && props.item.status !== status && status !== 'Reopen') || (tabItem === 'All Closed' && props.item.status !== status && status === 'Reopen')) ? _c('v-list-tile', {
              key: i,
              on: {
                "click": function($event) {
                  return _vm.prepareTicketStatus(props.item, status)
                }
              }
            }, [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(status) + "\n                    ")])], 1) : _vm._e()
          })], 2), _vm._v(" "), (props.item.status !== 'Completed' && props.item.status !== 'Cancelled') ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareTicketStatus(props.item, 'Comment')
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("comment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Comment")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.prepareUpdate(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Update")])], 1), _vm._v(" "), (props.item.status === 'New' && props.item.assigned_to_name === null) ? _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.deleteTicket(props.item)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Delete")])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
            on: {
              "click": function($event) {
                return _vm.loadTimeLine(props.item.ticket_id)
              }
            }
          }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("timeline")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Timeline")])], 1)], 1)], 1)], 1)])]
        }
      }], null, true)
    })], 1)], 1)], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-speed-dial', {
    staticStyle: {
      "position": "fixed",
      "top": "90px",
      "right": "10px"
    },
    attrs: {
      "direction": _vm.$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'
    },
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "small": "",
      "fab": "",
      "color": "accent"
    },
    slot: "activator",
    model: {
      value: (_vm.calFab),
      callback: function($$v) {
        _vm.calFab = $$v
      },
      expression: "calFab"
    }
  }, [_c('v-icon', [_vm._v("remove_red_eye")]), _vm._v(" "), _c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "mr-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'card' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('card')
            }
          }
        }, on), [_c('v-icon', [_vm._v("filter_frames")])], 1)]
      }
    }], null, false, 2865765141)
  }, [_vm._v(" "), _c('span', [_vm._v("Card view")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "ma-1",
          attrs: {
            "fab": "",
            "small": "",
            "color": _vm.choosenView === 'list' ? 'info' : ''
          },
          nativeOn: {
            "click": function($event) {
              return _vm.changeView('list')
            }
          }
        }, on), [_c('v-icon', [_vm._v("list")])], 1)]
      }
    }], null, false, 1363469397)
  }, [_vm._v(" "), _c('span', [_vm._v("List view")])])], 1)], 2) : _vm._e()], 1), _vm._v(" "), (_vm.lAction === 'Create' || _vm.lAction === 'Update') ? _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "sForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveTicket(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pa-0 ml-3"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction) + ' Request') + "\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "label": "Department",
      "item-value": "dept_id",
      "item-text": "dept_name",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadCategories(_vm.lSupport.dep_pair)
      }
    },
    model: {
      value: (_vm.lSupport.dep_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "dep_pair", $$v)
      },
      expression: "lSupport.dep_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Category",
      "items": _vm.catList,
      "item-value": "cat_id",
      "item-text": "cat",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSubCatList(_vm.lSupport.cat_pair)
      }
    },
    model: {
      value: (_vm.lSupport.cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "cat_pair", $$v)
      },
      expression: "lSupport.cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Sub Category",
      "items": _vm.subCatList,
      "item-value": "sub_cat_id",
      "item-text": "sub_cat",
      "return-object": "",
      "hide-details": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadSubCatList(_vm.lSupport.sub_cat_pair)
      }
    },
    model: {
      value: (_vm.lSupport.sub_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "sub_cat_pair", $$v)
      },
      expression: "lSupport.sub_cat_pair"
    }
  })], 1), _vm._v(" "), (_vm.lSupport.sub_cat_pair.sub_cat === 'Others') ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Others",
      "hide-details": "",
      "maxlength": "50"
    },
    model: {
      value: (_vm.lSupport.others),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "others", $$v)
      },
      expression: "lSupport.others"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.assignUserList,
      "label": "Assigned to",
      "item-text": "emp_name_with_id",
      "item-value": "emp_id",
      "hide-details": "",
      "return-object": "",
      "disabled": _vm.lSupport.comm_id != 126
    },
    model: {
      value: (_vm.lSupport.assigned_to_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "assigned_to_pair", $$v)
      },
      expression: "lSupport.assigned_to_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.priorityList,
      "label": "Priority",
      "item-text": "priority",
      "item-value": "priority_id",
      "return-object": "",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "disabled": _vm.lSupport.status === 'Completed' || _vm.lSupport.status === 'Cancelled'
    },
    model: {
      value: (_vm.lSupport.priority_pair),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "priority_pair", $$v)
      },
      expression: "lSupport.priority_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": ['New', 'In Progress', 'On-Hold', 'Need More Info.', 'Job-Done', 'Completed', 'Cancelled', 'Reopen'],
      "label": "Status",
      "hide-details": "",
      "disabled": _vm.lAction === 'Create' || _vm.lAction === 'Update'
    },
    model: {
      value: (_vm.lSupport.status),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "status", $$v)
      },
      expression: "lSupport.status"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Description",
      "rows": "2",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "3000",
      "box": ""
    },
    model: {
      value: (_vm.lSupport.description),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "description", $$v)
      },
      expression: "lSupport.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.planned_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "planned_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "planned_start_dt", $event)
      }
    },
    model: {
      value: (_vm.planStartDt),
      callback: function($$v) {
        _vm.planStartDt = $$v
      },
      expression: "planStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Planned Start Date",
      "rules": [_vm.rules.required],
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.planned_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_start_dt", $$v)
      },
      expression: "lSupport.planned_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.planned_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_start_dt", $$v)
      },
      expression: "lSupport.planned_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planStartDt.save(_vm.lSupport.planned_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "planEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.planned_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "planned_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "planned_end_dt", $event)
      }
    },
    model: {
      value: (_vm.planEndDt),
      callback: function($$v) {
        _vm.planEndDt = $$v
      },
      expression: "planEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Planned End Date",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_end_dt", $$v)
      },
      expression: "lSupport.planned_end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "min": _vm.lSupport.planned_start_dt,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "planned_end_dt", $$v)
      },
      expression: "lSupport.planned_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.planEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.planEndDt.save(_vm.lSupport.planned_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "actStartDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.act_start_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "act_start_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "act_start_dt", $event)
      }
    },
    model: {
      value: (_vm.actStartDt),
      callback: function($$v) {
        _vm.actStartDt = $$v
      },
      expression: "actStartDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual Start Date",
      "append-icon": "event",
      "disabled": "",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.act_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_start_dt", $$v)
      },
      expression: "lSupport.act_start_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.act_start_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_start_dt", $$v)
      },
      expression: "lSupport.act_start_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actStartDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.actStartDt.save(_vm.lSupport.act_start_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "actEndDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.act_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "act_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "act_end_dt", $event)
      }
    },
    model: {
      value: (_vm.actEndDt),
      callback: function($$v) {
        _vm.actEndDt = $$v
      },
      expression: "actEndDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Actual End Date",
      "disabled": "",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.act_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_end_dt", $$v)
      },
      expression: "lSupport.act_end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lSupport.act_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "act_end_dt", $$v)
      },
      expression: "lSupport.act_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.actEndDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.actEndDt.save(_vm.lSupport.act_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-dialog', {
    ref: "jobDoneDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lSupport.job_done_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lSupport, "job_done_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lSupport, "job_done_dt", $event)
      }
    },
    model: {
      value: (_vm.jobDoneDt),
      callback: function($$v) {
        _vm.jobDoneDt = $$v
      },
      expression: "jobDoneDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Job Done Date",
      "append-icon": "event",
      "disabled": "",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lSupport.job_done_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "job_done_dt", $$v)
      },
      expression: "lSupport.job_done_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "disabled": ""
    },
    model: {
      value: (_vm.lSupport.job_done_dt),
      callback: function($$v) {
        _vm.$set(_vm.lSupport, "job_done_dt", $$v)
      },
      expression: "lSupport.job_done_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.jobDoneDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.jobDoneDt.save(_vm.lSupport.job_done_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lSupport)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lSupport.files && _vm.lSupport.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lSupport.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [(!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "ml-0 info lighten-1 grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "ml-0"
    }, [_vm._v(_vm._s(file.file_name))])])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (upto 20MB)")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-3"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved || _vm.lSupport.status === 'Completed' || _vm.lSupport.status === 'Cancelled'
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showDlgStatus),
      callback: function($$v) {
        _vm.showDlgStatus = $$v
      },
      expression: "showDlgStatus"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-2 title"
  }, [_vm._v("\n      " + _vm._s('Add comments for ' + _vm.lTicketStatus.action) + "\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "black--text"
  }, [(_vm.lTicketStatus.action === 'Completed') ? _c('v-flex', {
    staticClass: "pt-2 pl-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "sm5": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgEndDate",
    attrs: {
      "persistent": "",
      "max-width": "290px",
      "return-value": _vm.lTicketStatus.planned_end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lTicketStatus, "planned_end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lTicketStatus, "planned_end_dt", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "slot": "activator",
            "label": "Completed date",
            "append-icon": "mdi-calendar-today",
            "readonly": "",
            "clearable": "",
            "hide-details": "",
            "rules": [_vm.rules.required]
          },
          slot: "activator",
          model: {
            value: (_vm.lTicketStatus.planned_end_dt),
            callback: function($$v) {
              _vm.$set(_vm.lTicketStatus, "planned_end_dt", $$v)
            },
            expression: "lTicketStatus.planned_end_dt"
          }
        }, on))]
      }
    }], null, false, 1026145621),
    model: {
      value: (_vm.dlgEndDate),
      callback: function($$v) {
        _vm.dlgEndDate = $$v
      },
      expression: "dlgEndDate"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "max": _vm.today,
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.lTicketStatus.planned_end_dt),
      callback: function($$v) {
        _vm.$set(_vm.lTicketStatus, "planned_end_dt", $$v)
      },
      expression: "lTicketStatus.planned_end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgEndDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgEndDate.save(_vm.lTicketStatus.planned_end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "hide-details": "",
      "outline": "",
      "placeholder": _vm.placeHolder,
      "maxlength": "250"
    },
    model: {
      value: (_vm.lTicketStatus.notes),
      callback: function($$v) {
        _vm.$set(_vm.lTicketStatus, "notes", $$v)
      },
      expression: "lTicketStatus.notes"
    }
  })], 1), _vm._v(" "), (_vm.lTicketStatus.action === 'Comment') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "statusFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromBrowser(_vm.lTicketStatus)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lTicketStatus.files && _vm.lTicketStatus.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', _vm._l((_vm.lTicketStatus.files.filter(function (rec) { return rec.is_selected; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      on: {
        "input": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v("\n          " + _vm._s(file.file_name) + "\n          "), (!file.is_changed) ? _c('span', [_c('a', {
      staticStyle: {
        "text-decoration": "none"
      },
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_c('v-btn', {
      staticClass: "ml-1 info grey--text text--lighten-4",
      attrs: {
        "small": "",
        "icon": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("file_download")])], 1)], 1)]) : _vm._e()])], 1)
  }), 0) : _c('span', [_vm._v("Attachment(images, pdf, doc, word, excel) if any")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDlgStatus = false
      }
    }
  }, [_vm._v("cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.postTicketStatus()
      }
    }
  }, [_vm._v("submit")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "600px"
    },
    model: {
      value: (_vm.showTimeline),
      callback: function($$v) {
        _vm.showTimeline = $$v
      },
      expression: "showTimeline"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "py-1 title info lighten-1"
  }, [_c('div', [_vm._v("Timeline")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showTimeline = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pl-0 pr-4 py-3"
  }, [_c('v-timeline', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.lTimeLine), function(timeline, n) {
    return _c('v-timeline-item', {
      key: n,
      class: n === _vm.lTimeLine.length - 1 ? 'pb-0' : '',
      attrs: {
        "small": "",
        "id": 'timeline_' + n
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function() {
          return [_c('v-avatar', [_c('img', {
            attrs: {
              "src": _vm.config.STATIC_FILES_DIR + timeline.avatar_url
            }
          })])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _c('v-card', {
      staticClass: "grey lighten-4"
    }, [(timeline.action === 'Ticket Updated') ? _c('div', [_c('v-card-title', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(timeline.action) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0 pb-2"
    }, [(timeline.notes !== '') ? _c('div', [(timeline.action === 'Ticket Updated') ? _c('div', [(timeline.assign_comments !== '') ? _c('div', {
      staticClass: "pb-1"
    }, [(timeline.assign_comments !== '') ? _c('b', [_vm._v("Assignee Comments: ")]) : _vm._e(), _vm._v(_vm._s(timeline.assign_comments) + "\n                  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v("Notes: ")]), _vm._v(" "), _vm._l((timeline.timeLineNote), function(note, i) {
      return _c('div', {
        key: i
      }, [(note) ? _c('span', [_vm._v(_vm._s(i + 1 + '. ' + note))]) : _vm._e()])
    })], 2)]) : _c('div', {
      staticClass: "pb-1"
    }, [_c('b', [_vm._v("Notes: ")]), _vm._v(_vm._s(timeline.notes) + "\n                ")])]) : _c('div', [(timeline.is_updated_by_sv_user === false) ? _c('div', [_c('b', [_vm._v("Assigned to: ")]), _vm._v(_vm._s(timeline.assigned_to_name))]) : _vm._e(), _vm._v(" "), (timeline.assign_comments !== '') ? _c('div', {
      staticClass: "pb-1"
    }, [(timeline.assign_comments !== '') ? _c('b', [_vm._v("Assignee Comments: ")]) : _vm._e(), _vm._v(_vm._s(timeline.assign_comments) + "\n                ")]) : _vm._e()])])], 1) : _c('div', [_c('v-card-title', {
      staticClass: "title pa-2"
    }, [_vm._v("\n              " + _vm._s(timeline.action) + "\n            ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pt-0 pb-2"
    }, [(timeline.action === 'Assigned' || timeline.is_updated_by_sv_user === false) ? _c('div', [_c('b', [_vm._v("Assigned to: ")]), _vm._v(" " + _vm._s(timeline.assigned_to_name))]) : _vm._e(), _vm._v(" "), (timeline.action === 'Ticket Created') ? _c('div', [_c('b', [_vm._v("Description: ")]), _vm._v(_vm._s(timeline.notes))]) : _c('div', [_c('b', [_vm._v("Comments: ")]), _vm._v(_vm._s(timeline.notes))])])], 1), _vm._v(" "), (_vm.lTimeLine.attachImages && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id; }).length ||
      _vm.lTimeLine.attachFile && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && timeline.ticket_det_id === rec.ticket_det_id; })) ? _c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "grid-list-sm": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(_vm.lTimeLine.attachImages.length && _vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action; }).length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "ml-1",
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                    Image Attachments\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('div', {
      directives: [{
        name: "viewer",
        rawName: "v-viewer",
        value: (_vm.options),
        expression: "options"
      }],
      staticClass: "clearfix"
    }, [_vm._l((_vm.lTimeLine.attachImages), function(file, index) {
      return [((file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)) ? _c('span', [_c('img', {
        key: index,
        staticClass: "ma-1",
        staticStyle: {
          "display": "inline-block",
          "cursor": "pointer"
        },
        attrs: {
          "width": "80px",
          "src": file.file_url,
          "data-source": file.file_url
        }
      })]) : _vm._e()]
    })], 2)])], 1) : _vm._e(), _vm._v(" "), (_vm.lTimeLine.attachFile.length && _vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action; }).length > 0) ? _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": ""
      }
    }, [((_vm.lTimeLine.attachImages.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0) && (_vm.lTimeLine.attachFile.filter(function (rec) { return rec.action === timeline.action && rec.ticket_det_id === timeline.ticket_det_id; }).length > 0)) ? _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-layout', {
      staticClass: "caption grey--text mb-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "ml-1",
      attrs: {
        "xs6": "",
        "sm8": ""
      }
    }, [_vm._v("\n                    Other Attachments\n                  ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, _vm._l((_vm.lTimeLine.attachFile), function(file, index) {
      return _c('span', {
        key: index
      }, [((file.action === timeline.action && file.ticket_det_id === timeline.ticket_det_id)) ? _c('v-chip', [_c('a', {
        staticStyle: {
          "text-decoration": "none"
        },
        attrs: {
          "href": file.file_url,
          "download": ""
        }
      }, [_c('v-btn', {
        staticClass: "ml-0 pa-0 info lighten-1 grey--text text--lighten-4",
        attrs: {
          "small": "",
          "icon": ""
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("file_download")])], 1)], 1), _vm._v("\n                    " + _vm._s(file.file_name) + "\n                  ")]) : _vm._e()], 1)
    }), 0)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
      staticClass: "caption pa-2"
    }, [_vm._v("\n        " + _vm._s(timeline.created_by_name) + "\n        "), _c('span', {
      staticClass: "grey--text pl-2"
    }, [_vm._v(_vm._s(_vm.handy.formatDate(timeline.action_dt) + ' ' + _vm.handy.getTime12Hrs(timeline.action_dt)))])])], 1)], 1)
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text"
  }, [_vm._v("Filter by attributes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.departmentList,
      "label": "Department",
      "item-text": "dept_name",
      "item-value": "dept_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.loadCategories(_vm.filterListByTab[_vm.tab].ticket_dept_list)
      }
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_dept_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_dept_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_dept_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.catList,
      "label": "Category",
      "item-text": "cat",
      "item-value": "cat_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_cat_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Priority",
      "items": _vm.priorityList,
      "item-text": "priority",
      "item-value": "priority_id",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].priority_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "priority_list", $$v)
      },
      expression: "filterListByTab[tab].priority_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.filterStatus,
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].ticket_status_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "ticket_status_list", $$v)
      },
      expression: "filterListByTab[tab].ticket_status_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by people")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Created by",
      "items": _vm.mcList,
      "item-text": "user_name",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].created_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "created_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].created_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.assignUserList,
      "label": "Assigned to",
      "item-text": "emp_name_with_id",
      "dense": "",
      "hide-details": "",
      "return-object": ""
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].assigned_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "assigned_user_pair_list", $$v)
      },
      expression: "filterListByTab[tab].assigned_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by date")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDate),
      callback: function($$v) {
        _vm.dlgFromDate = $$v
      },
      expression: "dlgFromDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due from",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "from_dt", $$v)
      },
      expression: "filterListByTab[tab].from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDate.save(_vm.filterListByTab[_vm.tab].from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterListByTab[_vm.tab].end_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDate),
      callback: function($$v) {
        _vm.dlgToDate = $$v
      },
      expression: "dlgToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Due till",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": "",
      "required": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterListByTab[_vm.tab].end_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $$v)
      },
      expression: "filterListByTab[tab].end_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterListByTab[_vm.tab].end_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterListByTab[_vm.tab], "end_dt", $$v)
      },
      expression: "filterListByTab[tab].end_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDate.save(_vm.filterListByTab[_vm.tab].end_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e(), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:25px;' : 'bottom:15px; left:315px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareFilter()
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(_vm.enabledFilter[this.tab]) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.aa50ea440a174388ecc3.js